// English UI copy (default locale). UPPER_SNAKE_CASE keys; `${var}` interpolated.
export const en = Object.freeze({
  // ── Field names: one label per business field, wherever it appears ──
  FIELD_STATUS: 'Status',
  FIELD_MATERIAL_NAME: 'Material name',
  FIELD_SUPPLIER_NAME: 'Supplier name',
  FIELD_FACILITY_NAME: 'Site / B2B account name',
  FIELD_TERMINAL: 'Terminal',
  FIELD_SITE_OR_B2B_ACCOUNT_NAME: 'Site / B2B account name',
  FIELD_COUNTRY_OF_ORIGIN: 'Country of origin',
  FIELD_RAW_MATERIAL_TYPE: 'Raw material type',
  FIELD_FEEDSTOCK_CATEGORY: 'Feedstock category',
  FIELD_ALLOCATION_PREFERENCE: 'Allocation preference',
  FIELD_GHG_EMISSIONS: 'GHG emissions',
  FIELD_DATE_OF_DISPATCH: 'Date of dispatch',
  FIELD_DATE_OF_DISCHARGE: 'Date of discharge',
  FIELD_DELIVER_BY: 'Deliver by',
  FIELD_DISCREPANCIES: 'Discrepancies',
  FIELD_ACTION: 'Action',
  FIELD_FILE_NAME: 'File name',
  FIELD_UNIT_TYPE: 'Unit type: ${unit}',
  FIELD_SHIPMENT_ID: 'Shipment ID',
  FIELD_CONTRACT_ID: 'Contract ID',
  FIELD_CONTRACT_NUMBER: 'Contract number',
  FIELD_DECLARATION_NO: 'Declaration no.',
  FIELD_SITE_NAME: 'Site name',
  FIELD_SITE_ID: 'Site ID',
  FIELD_OFFICIAL_SITE_NAME: 'Official site name (For declaration)',
  FIELD_TERMINAL_ID: 'Terminal ID',
  FIELD_CERTIFICATION_TYPE: 'Certification type',
  FIELD_SITE_TYPE: 'Site type',
  FIELD_CERTIFICATION_STATUS: 'Certification status',
  FIELD_ISCC_CERTIFICATE_NUMBER: 'ISCC certificate number',
  FIELD_ACCOUNT_NAME: 'Account name',
  FIELD_ACCOUNT_ID: 'Account ID',
  FIELD_VALID_FROM: 'Valid from',
  FIELD_VALID_TILL: 'Valid till',
  FIELD_MATERIAL_ID: 'Material ID',
  FIELD_REFERENCE_ID: 'Reference ID',
  FIELD_MATERIAL_TYPE: 'Material type',
  FIELD_MATERIAL_ROLE: 'Material role',
  FIELD_ASSOCIATED_PROCESS: 'Associated process(Process ID)',
  FIELD_DECLARATION_SETTINGS: 'Declaration settings',
  FIELD_WORKING_UNIT: 'Working unit',
  FIELD_CONVERSION_FACTOR: 'Conversion factor / Density',
  FIELD_ENERGY_CONTENT_PER_UNIT: 'Energy content',
  FIELD_ADDRESS_LINE_1: 'Address line 1',
  FIELD_ADDRESS_LINE_2: 'Address line 2',
  FIELD_CITY_NAME: 'City name',
  FIELD_COUNTRY_NAME: 'Country name',
  FIELD_ZIP_CODE: 'ZIP code',
  FIELD_LAST_UPDATED: 'Last updated',

  // ── Filter panel ──
  FILTER_LAST_7_DAYS: 'Last 7 days',
  FILTER_LAST_30_DAYS: 'Last 30 days',
  FILTER_LAST_60_DAYS: 'Last 60 days',
  FILTER_SELECT_RANGE: 'Select range',

  // ── Shared actions, sections and form labels ──
  LINK_STEP_ASSIGN: 'Assign quantity',
  ACTION_ADD_ATTACHMENT: 'Add attachment',
  ACTION_ADD_ATTACHMENTS: 'Add attachments',
  ACTION_ADD_DECLARATIONS: 'Add declarations',
  ACTION_SKIP_FOR_NOW: 'Skip for now',
  ACTION_FULFILL: 'Fulfill',
  ACTION_LINK_CONTRACT: 'Link contract',
  ACTION_LINK_SHIPMENT: 'Link shipment',
  ACTION_LINK_SHIPMENTS: 'Link shipments',
  ACTION_RECEIVE_SHIPMENT: 'Receive shipment',
  ACTION_REMOVE_LINKAGE: 'Remove linkage',
  ACTION_UPDATE_SHIPMENT: 'Update shipment',
  ACTION_VIEW_DISCREPANCIES: 'View discrepancies',
  ATTACHMENTS_EMPTY_DESCRIPTION:
    'No attachments have been added yet. You can add documents like bill of lading, invoice etc., here for audit purposes.',
  ATTACHMENTS_EMPTY_TITLE: 'No attachments found',
  COMMON_DELETE: 'Delete',
  COMMON_EDIT: 'Edit',
  COMMON_MORE_ACTIONS: 'More actions',
  COMMON_NO_RESULTS_DESCRIPTION: 'Try a different search term or clear your filters.',
  FIELD_ACTUAL_SHIPMENT_QUANTITY: 'Actual shipment quantity',
  FIELD_ALLOCATED_QUANTITY: 'Allocated quantity',
  FIELD_ASSIGNED_QUANTITY_CONTRACT: 'Assigned quantity (This contract)',
  FIELD_ASSIGNED_QUANTITY_DECLARATION: 'Assigned qty. (This declaration)',
  FIELD_ASSIGNED_QUANTITY_SHIPMENT: 'Assigned quantity (This shipment)',
  FIELD_ASSIGNED_QUANTITY_ORDER: 'Assigned quantity (This order)',
  FIELD_AVAILABLE_QUANTITY: 'Available quantity',
  FIELD_AVAILABLE_QUANTITY_IN_UNIT: 'Available quantity (in ${unit})',
  FIELD_CLOSING_BALANCE: 'Closing balance',
  FIELD_CONTRACTED_QUANTITY: 'Contracted quantity',
  FIELD_DAYS_LEFT: 'Days left',
  FIELD_DECLARATION: 'Declaration',
  FIELD_DECLARATION_NUMBER: 'Declaration number',
  FIELD_DECLARATION_UNIT: 'Declaration unit',
  FIELD_DISPATCH_BY: 'Dispatch by',
  FIELD_GHG_EMISSION_SAVINGS: 'GHG emission savings',
  FIELD_INBOUND_QUANTITY: 'Inbound quantity',
  FIELD_INBOUND_TYPE: 'Inbound type',
  FIELD_MASS_BALANCE_PERIOD_NAME: 'Mass balance period name',
  FIELD_OPENING_QUANTITY: 'Opening quantity',
  FIELD_OUTSTANDING_QUANTITY: 'Outstanding quantity',
  FIELD_PENDING_QUANTITY: 'Pending quantity',
  FIELD_PERIOD: 'Period',
  FIELD_PERIOD_END_DATE: 'Period end date',
  FIELD_PERIOD_NAME: 'Period name',
  FIELD_PERIOD_START_DATE: 'Period start date',
  FIELD_QUANTITY: 'Quantity',
  FIELD_RECEIVED_AT: 'Site / B2B account name',
  FIELD_RECEIVED_DECLARATION_QUANTITY: 'Received declaration quantity',
  FIELD_SENT_BY: 'Sent by',
  FIELD_REMAINING_TO_ALLOCATE_QUANTITY: 'Remaining to allocate quantity',
  FIELD_SERIAL_NO: 'S.No.',
  FIELD_SHIPMENT_QUANTITY: 'Shipment quantity',
  FIELD_SHIPPED_QUANTITY: 'Shipped quantity',
  FIELD_SHIPPING_SITES: 'Shipping sites',
  FIELD_SHIPPING_FROM: 'Shipping from',
  FIELD_SUPPLIER_ID: 'Supplier ID',
  FIELD_PRIMARY_CONTACT: 'Primary contact',
  FIELD_SITE: 'Site',
  FIELD_TOTAL_ORDER_LINKED: 'Total order linked',
  FIELD_SHIPPING_TO: 'Shipping to (sites)',
  FIELD_SOLD_TO: 'Sold to',
  FIELD_TERMINAL_NAME: 'Terminal name',
  FIELD_TIME_PERIOD: 'Time period',
  FIELD_LINKED_CONTRACTS: 'Linked contracts',
  FIELD_LINKED_SHIPMENTS: 'Linked shipments',
  FIELD_TOTAL_CONTRACTS_LINKED: 'Total contracts linked',
  FIELD_TOTAL_DECLARATIONS_LINKED: 'Total declarations linked',
  FIELD_TOTAL_SHIPMENT_LINKED: 'Total shipment linked',
  FIELD_UNASSIGNED_QUANTITY: 'Unassigned quantity',
  FIELD_UNIT: 'Unit',
  FIELD_VESSEL: 'Vessel',
  FIELD_VESSEL_NAME: 'Vessel name',
  FORM_ADDRESS_LINE_1: 'Address line 1',
  FORM_ADDRESS_LINE_1_PLACEHOLDER: 'Enter address line 1',
  FORM_ADDRESS_LINE_2: 'Address line 2 (Optional)',
  FORM_ADDRESS_LINE_2_PLACEHOLDER: 'Enter address line 2',
  FORM_CITY_NAME: 'City name',
  FORM_CITY_NAME_PLACEHOLDER: 'Enter city name',
  FORM_COMPANY_ID: 'Company ID',
  FORM_COMPANY_ID_PLACEHOLDER: 'Enter company ID',
  FORM_COMPANY_NAME: 'Company name',
  FORM_COMPANY_NAME_PLACEHOLDER: 'Enter company name',
  FORM_COUNTRY_NAME: 'Country name',
  FORM_COUNTRY_NAME_PLACEHOLDER: 'Enter country name',
  FORM_ZIP_CODE: 'ZIP code',
  FORM_ZIP_CODE_PLACEHOLDER: 'Enter ZIP code',
  FORM_ALLOCATION_PREFERENCE: 'Allocation preference (Optional)',
  FORM_COUNTRY_OF_ORIGIN: 'Country of origin (Optional)',
  FORM_COUNTRY_OF_ORIGIN_PLACEHOLDER: 'Select country of origin',
  FORM_FEEDSTOCK_CATEGORY: 'Feedstock category (Optional)',
  FORM_ADD_ATTACHMENTS: 'Add attachments (Optional)',
  FORM_ATTACHMENTS_HINT: 'Supported format: pdf (Total no. of files: 5, Maximum file size: 5 MB)',
  FORM_SELECT_FACILITY_FIRST: 'Select a facility first',
  FORM_SELECT_CUSTOMER_FIRST: 'Select a customer first',
  FORM_TERMINAL_EMPTY: 'No terminals for this facility',
  FORM_MATERIAL_EMPTY: 'No materials assigned to this facility',
  FORM_SHIPPING_TO_EMPTY: 'No delivery sites for this customer',
  FORM_GENERATE: 'Generate',
  FORM_ORGANIZATION_NAME_PLACEHOLDER: 'Enter organization name',
  FORM_SUPPLIER_ID_PLACEHOLDER: 'Enter supplier ID',
  FORM_PRIMARY_CONTACT_NAME_OPTIONAL: 'Primary contact name (Optional)',
  FORM_PRIMARY_CONTACT_NAME_PLACEHOLDER: 'Enter primary contact name',
  FORM_SHIPPING_LOCATION_PLACEHOLDER: 'Enter shipping location',
  FORM_SITE_MANAGER_NAME_OPTIONAL: "Site manager's name (optional)",
  FORM_SITE_MANAGER_NAME_PLACEHOLDER: 'Enter site manager name',
  FORM_SITE_MANAGER_EMAIL_OPTIONAL: "Site manager's email ID (optional)",
  FORM_SITE_MANAGER_EMAIL_PLACEHOLDER: 'Ex. paul.bryson@chemical.com',
  FORM_GHG_EMISSIONS: 'GHG emissions (g CO2 e / MJ) (Optional)',
  FORM_GHG_EMISSIONS_PLACEHOLDER: 'Enter the GHG emissions',
  FORM_GHG_EMISSION_SAVINGS: 'GHG emission savings (Optional)',
  FORM_GHG_EMISSION_SAVINGS_PLACEHOLDER: 'Enter the GHG emission savings',
  FORM_MULTI_SITE_TRANSFER: 'Multisite transfer',
  FORM_QUANTITY_PLACEHOLDER: 'Enter quantity',
  FORM_RAW_MATERIAL_TYPE: 'Raw material type (Optional)',
  FORM_RAW_MATERIAL_TYPE_PLACEHOLDER: 'Select raw material type',
  FORM_RECEIVED_AT_FACILITY: 'Received at - Site / B2B account name',
  FORM_REMOVE_FILE: 'Remove ${name}',
  FORM_SELECT_CERTIFICATION_STATUS: 'Select certification status',
  FORM_SELECT_CERTIFICATION_TYPE: 'Select certification type',
  FORM_SELECT_COUNTRY: 'Select country',
  FORM_SELECT_FACILITY: 'Select facility',
  FORM_SELECT_MATERIAL: 'Select material',
  FORM_SELECT_MATERIALS: 'Select materials',
  FORM_SELECT_MATERIAL_FIRST: 'Select a material first',
  FORM_SELECT_SITE_TYPE: 'Select site type',
  FORM_SELECT_SUPPLIER: 'Select supplier',
  FORM_SELECT_TERMINAL: 'Select terminal',
  FORM_ENTER_PERIOD_NAME: 'Enter period name',
  FORM_MB_PERIOD_COUNT: 'Enter the total number of periods in the year',
  FORM_MB_PERIOD_COUNT_PLACEHOLDER: 'Select the total number of periods',
  FORM_MB_PERIOD_DATES: 'Set the start and end date of each period',
  FORM_MB_PERIOD_CARRY_FORWARD: 'Enable automatic carry-forward to next mass balance period',
  FORM_SELECT_TYPE: 'Select type',
  FORM_SELECT_UNIT: 'Select unit',
  FORM_SITE_NAME_PLACEHOLDER: 'Enter site name',
  FORM_OFFICIAL_SITE_NAME_PLACEHOLDER: 'Enter official site name',
  FORM_SITE_ID_PLACEHOLDER: 'Enter site ID',
  FORM_TERMINAL_NAME_PLACEHOLDER: 'Enter terminal name',
  FORM_TERMINAL_ID_PLACEHOLDER: 'Enter terminal ID',
  FORM_ISCC_CERTIFICATE_NUMBER_PLACEHOLDER: 'Enter ISCC certificate number',
  FORM_ISCC_CERTIFICATE_NUMBER_OPTIONAL: 'ISCC certificate number (Optional)',
  FORM_MATERIAL_NAME_PLACEHOLDER: 'Enter material name',
  FORM_MATERIAL_ID_PLACEHOLDER: 'Enter material ID',
  FORM_REFERENCE_ID_OPTIONAL: 'Reference ID (Optional)',
  FORM_REFERENCE_ID_PLACEHOLDER: 'Enter reference ID',
  FORM_SELECT_MATERIAL_TYPE: 'Select material type',
  FORM_SELECT_DECLARATION_UNIT: 'Select declaration unit',
  FORM_WORKING_UNIT_OPTIONAL: 'Working unit (Optional)',
  FORM_SELECT_WORKING_UNIT: 'Select working unit',
  FORM_CONVERSION_FACTOR_PLACEHOLDER: 'Enter conversion factor',
  FORM_DENSITY_PLACEHOLDER: 'Enter density',
  FORM_TOTAL_ENERGY_CONTENT: 'Total energy content (Optional)',
  UNIT_GROUP_WEIGHT: 'Weight',
  UNIT_GROUP_VOLUME: 'Volume',
  UNIT_MT: 'MT (Metric Tons)',
  UNIT_KG: 'kg (Kilograms)',
  UNIT_LBS: 'Lbs (Pounds)',
  UNIT_CUBIC_METER: 'm³ (Cubic meters)',
  UNIT_CUBIC_METER_15C: 'm³ /15°C',
  UNIT_GALLON: 'gal (Gallons)',
  UNIT_MJ_PER_KG: 'MJ/kg',
  UNIT_MJ_PER_LITRE: 'MJ/l',
  FORM_ACCOUNT_NAME: 'Account name',
  FORM_ACCOUNT_NAME_PLACEHOLDER: 'Enter account name',
  FORM_ACCOUNT_ID: 'Account ID',
  FORM_ACCOUNT_ID_PLACEHOLDER: 'Enter account ID',
  FORM_SENT_BY_SUPPLIER: 'Sent by - Supplier',
  FORM_SHIPMENT_QUANTITY_UNIT: 'Unit of shipment quantity',
  FORM_SHIPPING_TO_OPTIONAL: 'Shipping to (site) (Optional)',
  FORM_SHIPPING_SITES: 'Shipping sites',
  FORM_TERMINAL_OPTIONAL: 'Terminal (Optional)',
  SHIPMENT_TERMINAL_MISSING_ORDER_MATERIAL:
    "This terminal isn't assigned the order's material. Pick another, or assign the material in Material settings.",
  FORM_TRANSPORT_NAME: 'Transport name (Optional)',
  FORM_TRANSPORT_NAME_PLACEHOLDER: 'Enter transport name',
  FORM_UPLOAD_FILES: 'Upload files',
  FORM_VESSEL_NAME: 'Vessel name (Optional)',
  FORM_VESSEL_NAME_PLACEHOLDER: 'Enter vessel name',
  LINK_ASSIGN_REQUIRED: 'Assign a quantity to at least one row before saving.',
  REMOVE_LINKAGE_DESCRIPTION: 'Are you sure you want to remove this linkage?',
  SECTION_ATTACHMENTS: 'Attachments',
  SECTION_DECLARATIONS: 'Declarations',
  SECTION_CONFIGURATION: 'Configuration',
  SECTION_TIME_PERIOD: 'Time period',
  SECTION_CERTIFICATE_DETAILS: 'Certificate details',
  SECTION_DECLARATION_DETAILS: 'Declaration Details',
  SECTION_SHIPPING_ADDRESS: 'Shipping address',
  SECTION_TERMINAL_DETAILS: 'Terminal details',
  SECTION_GENERAL_DETAILS: 'General details',
  SECTION_OVERVIEW: 'Overview',
  SECTION_PREFERENCES: 'Preferences',
  SECTION_QUANTITY: 'Quantity',
  SECTION_CALCULATION: 'Calculation',
  SECTION_TRANSPORTATION_EMISSIONS: 'Transportation emissions',
  SECTION_QUANTITY_IN_UNIT: 'Quantity in ${unit} unit',
  SECTION_SUMMARY: 'Summary',
  SECTION_QUANTITY_IN_UNIT_TYPE: 'Quantity in ${unitType}',
  SECTION_QUANTITY_IN_WORKING_UNIT: 'Quantity in working unit',
  SECTION_QUANTITY_IN_DECLARATION_UNIT: 'Quantity in declaration unit',
  SECTION_QUANTITY_IN_TRACKING_UNIT: 'Quantity in tracking unit',
  SECTION_ADDITIONAL_DETAILS: 'Additional details',
  SECTION_SUSTAINABILITY: 'Sustainability attributes',

  // ── Status vocabularies: one per backend enum, universal across every screen ──
  STATUS_CONTRACT_ACTIVE: 'Active',
  STATUS_CONTRACT_CLOSED: 'Closed',
  STATUS_SHIPMENT_TO_RECEIVE: 'To receive',
  STATUS_SHIPMENT_PARTIALLY_RECEIVED: 'Partially received',
  STATUS_SHIPMENT_RECEIVED: 'Received',
  STATUS_SHIPMENT_FORWARD: 'Forward',
  STATUS_DECLARATION_DRAFT: 'Draft',
  STATUS_DECLARATION_PROCESSING: 'Processing',
  STATUS_DECLARATION_COMPLETED: 'Completed',
  STATUS_DECLARATION_PENDING: 'Pending',
  STATUS_DECLARATION_CONSUMED: 'Consumed',
  STATUS_DECLARATION_REVOKED: 'Revoked',
  STATUS_DECLARATION_REJECTED: 'Rejected',
  STATUS_VERIFICATION_VERIFIED: 'Verified',
  STATUS_VERIFICATION_MANUALLY_VERIFIED: 'Manually verified',
  STATUS_VERIFICATION_PENDING: 'Pending',
  STATUS_VERIFICATION_REJECTED: 'Rejected',
  STATUS_VERIFICATION_NA: 'Not applicable',

  // ── Global-shell top navigation ──
  NAV_HOME: 'Home',
  NAV_NOTIFICATIONS: 'Notifications',

  // ── Home launcher ──
  HOME_WELCOME: 'Welcome back, ${name}',
  HOME_MODULES: 'Modules',
  HOME_NETWORKS: 'Networks',
  HOME_WORKSPACE_SETUP: 'Workspace setup',
  HOME_MODULE_ISCC_EU: 'ISCC EU',
  HOME_MODULE_ISCC_PLUS: 'ISCC PLUS',
  HOME_MODULE_ISCC_CORSIA: 'ISCC CORSIA',
  HOME_MANAGE_SUPPLIERS: 'Manage suppliers',
  HOME_MANAGE_CUSTOMERS: 'Manage customers',
  HOME_ADMIN_CENTER: 'Admin center',
  NAV_USER_MENU: 'User menu',
  NAV_PROFILE_SETTINGS: 'Profile settings',
  NAV_SIGN_OUT: 'Sign out',

  // ── Module workspace navigation ──
  NAV_INBOUNDS: 'Inbounds',
  NAV_CONTRACTS: 'Contracts',
  NAV_INCOMING_SHIPMENTS: 'Incoming shipments',
  NAV_INCOMING_DECLARATIONS: 'Incoming Declarations',
  NAV_OUTBOUNDS: 'Outbounds',
  NAV_ORDERS: 'Orders',
  NAV_OUTGOING_SHIPMENTS: 'Outgoing shipments',
  NAV_ALLOCATIONS: 'Allocations',
  NAV_MONITOR: 'Monitor',
  NAV_INVENTORY: 'Inventory',
  NAV_TRANSACTIONS: 'Transactions',

  // ── Generic ──
  ERROR_TITLE: 'Something went wrong',
  ERROR_GENERIC: 'Something went wrong. Please try again.',
  ERROR_UNEXPECTED_BODY:
    'An unexpected error occurred. Try again, or reload the page if it persists.',
  ACTION_TRY_AGAIN: 'Try again',
  ACTION_CONTINUE: 'Continue',

  // ── Validation ──
  VALIDATION_EMAIL: 'Enter a valid email address',
  VALIDATION_PASSWORD_STRENGTH: 'Password does not meet the requirements',
  VALIDATION_PASSWORDS_MISMATCH: 'Passwords do not match',

  // ── Auth · form fields ──
  AUTH_EMAIL_LABEL: 'Email ID',
  AUTH_EMAIL_PLACEHOLDER: 'Enter your email ID',
  AUTH_PASSWORD_LABEL: 'Password',
  AUTH_PASSWORD_PLACEHOLDER: 'Enter your password',
  AUTH_SHOW_PASSWORD: 'Show password',
  AUTH_NEW_PASSWORD_LABEL: 'New password',
  AUTH_NEW_PASSWORD_PLACEHOLDER: 'Enter new password',
  AUTH_CONFIRM_PASSWORD_LABEL: 'Confirm password',
  AUTH_CONFIRM_PASSWORD_PLACEHOLDER: 'Re-enter new password',
  AUTH_FIRST_NAME_LABEL: 'First name',
  AUTH_FIRST_NAME_PLACEHOLDER: 'Enter your first name',
  AUTH_LAST_NAME_LABEL: 'Last name',
  AUTH_LAST_NAME_PLACEHOLDER: 'Enter your last name',
  AUTH_FORGOT_EMAIL_LABEL: 'Enter your email linked to the account',
  AUTH_FORGOT_EMAIL_PLACEHOLDER: 'Enter your email',
  AUTH_OTP_LABEL: 'Enter OTP',

  // ── Auth · password requirements ──
  AUTH_PW_REQ_LENGTH: 'At least 8 characters long',
  AUTH_PW_REQ_LOWERCASE: 'One lowercase character',
  AUTH_PW_REQ_UPPERCASE: 'One uppercase character',
  AUTH_PW_REQ_SPECIAL: 'One number, symbol, or special characters such as ! @ # $ % ^ & *',

  // ── Auth · status and errors ──
  AUTH_SIGNING_IN: 'Signing you in…',
  AUTH_REDIRECTING: 'Redirecting you…',
  AUTH_CHECKING_INVITATION: 'Checking your invitation…',
  AUTH_CHECKING_RESET_LINK: 'Checking your reset link…',
  AUTH_INVALID_CREDENTIALS: 'Invalid email or password. Please try again.',
  AUTH_INVITATION_INVALID: 'This invitation link is invalid or has expired.',
  AUTH_RESET_LINK_INVALID: 'This password reset link is invalid or has expired.',
  AUTH_RESET_EMAIL_SENT: 'If your email is registered, you will receive a password reset link.',
  AUTH_RESEND_IN: 'Resend in ${seconds}s',
  AUTH_RESEND_PROMPT: 'Click here to resend?',

  // ── Auth · headings and actions ──
  AUTH_LOGIN_TITLE: 'Login to your account',
  AUTH_LOGIN_ACTION: 'Login',
  AUTH_FORGOT_PASSWORD_LINK: 'Forgot password?',
  AUTH_FORGOT_TITLE: 'Forgot password',
  AUTH_BACK_TO_LOGIN: 'Back to Login',
  AUTH_GO_TO_LOGIN: 'Go to login',
  AUTH_RESET_TITLE: 'Enter new password',
  AUTH_SET_PASSWORD_ACTION: 'Set password',
  AUTH_SIGNUP_WELCOME: 'Welcome to ${brand}',
  AUTH_CREATE_ACCOUNT_ACTION: 'Create account',
  AUTH_SIGNUP_DONE_TITLE: 'You’re all set',
  AUTH_SIGNUP_DONE_BODY: 'Your account has been created. You can now log in.',
  AUTH_SIGNUP_MISSING_TOKEN:
    'This sign-up link is missing its invitation token. Please use the link from your invitation email.',
  AUTH_OR: 'or',
  AUTH_LOGIN_MICROSOFT: 'Login with Microsoft',
  AUTH_LOGIN_GOOGLE: 'Login with Google',

  // ── Auth · OTP step ──
  AUTH_OTP_TITLE: 'We’ve just sent a code',
  AUTH_OTP_SENT_TO:
    'We have sent a one-time code to ${email} for authentication. Please check your spam folder if you cannot find it in your inbox.',
  AUTH_OTP_RESENT: 'OTP sent successfully. Please check your email.',
  AUTH_OTP_NO_CODE: 'Didn’t receive the code?',

  // ── Auth · footer ──
  AUTH_FOOTER_CONTACT: 'Get in touch',
  AUTH_FOOTER_PRIVACY: 'Privacy',
  AUTH_FOOTER_TERMS: 'Terms',

  // ── Auth · marketing carousel ──
  AUTH_SLIDE_MB_HEADING_1: 'Your ISCC mass balance,',
  AUTH_SLIDE_MB_HEADING_2: 'always audit-ready.',
  AUTH_SLIDE_MB_BODY: 'One ledger for ISCC EU, PLUS, and CORSIA managing high-stakes compliance.',
  AUTH_SLIDE_DECL_HEADING: 'Declarations in. Compliance out.',
  AUTH_SLIDE_DECL_BODY:
    'Drop a sustainability declaration. We extract every field, validate against ISCC rules, and post it to your mass balance — in seconds, not hours.',
  AUTH_SLIDE_STD_HEADING: 'Three standards. One ledger.',
  AUTH_SLIDE_STD_BODY:
    "Whether you're shipping HVO into Europe, plastics through PLUS, or SAF under CORSIA — Smart Balance handles every standard in one workspace.",

  // ── Data table (library <Table> chrome) ──
  TABLE_SEARCH: 'Search…',
  TABLE_ROWS_PER_PAGE: 'Rows per page:',
  TABLE_SELECTED: 'selected',
  TABLE_CLEAR_SELECTION: 'Clear selection',
  TABLE_FILTER: 'Filter',
  TABLE_FILTER_TITLE: 'Filters',

  // ── Common ──
  COMMON_YES: 'Yes',
  COMMON_NO: 'No',
  COMMON_ADD: 'Add',
  COMMON_SAVE: 'Save',
  COMMON_UPDATE: 'Update',
  COMMON_BACK: 'Back',
  COMMON_DISCARD_TITLE: 'Unsaved changes',
  COMMON_DISCARD_BODY_TITLE: 'You have unsaved changes',
  COMMON_DISCARD_DESCRIPTION:
    "Are you sure you don't want to save? All unsaved changes will be lost.",
  COMMON_DISCARD_QUESTION: 'Do you want to discard them?',
  COMMON_DISCARD_CHANGES: 'Discard changes',
  COMMON_CANCEL: 'Cancel',
  COMMON_CONFIRM: 'Confirm',
  COMMON_OPEN_DATE_PICKER: 'Open date picker',
  COMMON_CONTINUE: 'Continue',
  COMMON_REMOVE: 'Remove',
  COMMON_ASSIGN: 'Assign',
  COMMON_NEXT: 'Next',
  COMMON_ALLOCATION_HINT: 'Choose up to ${max} countries',
  COMMON_INVALID_ALLOCATION_MAX: 'Choose no more than ${max} countries',
  COMMON_SEARCH_RAW_MATERIAL: 'Search raw material types',
  COMMON_SEARCH_COUNTRY: 'Search countries',
  COMMON_SEARCH_MATERIAL: 'Search materials',
  COMMON_SEARCH_SUPPLIER: 'Search suppliers',
  COMMON_PREVIOUS: 'Previous',
  COMMON_CLOSE: 'Close',
  COMMON_APPLY: 'Apply',
  COMMON_RESET: 'Reset',
  COMMON_RETRY: 'Retry',
  COMMON_FROM: 'From',
  COMMON_TO: 'To',
  COMMON_SELECT: 'Select',
  COMMON_SEARCH: 'Search',
  COMMON_NONE: 'None',
  COMMON_NO_OPTIONS: 'No options available',
  COMMON_NO_MATCHES: 'No matches',
  COMMON_SEARCH_CUSTOMER: 'Search customers',

  // ── Unit types (shared by every table with unit switching) ──
  UNIT_WORKING: 'Working unit',
  UNIT_DECLARATION: 'Declaration unit',
  UNIT_TRACKING: 'Tracking unit',
  UNIT_MIXED: 'Mixed',
  UNIT_TYPE_ARIA: 'Unit type',
  UNIT_TYPE_ALL_ARIA: 'Unit type for every row',

  // ── Discrepancies (shared table cell) ──
  DISCREPANCIES_NONE: 'No discrepancies',
  DISCREPANCIES_FOUND_ONE: '1 discrepancy found',
  DISCREPANCIES_FOUND: '${count} discrepancies found',
  DISCREPANCIES_CAPPED: '${cap}+ discrepancies found',
  COMMON_LOADING: 'Loading…',
  COMMON_VIEW: 'View',

  // ── Validation ──
  VALIDATION_MAX_LENGTH: 'Use up to ${max} characters',
  VALIDATION_POSITIVE_NUMBER: 'Enter a positive number',
  VALIDATION_PERCENTAGE_MAX: 'Enter a percentage of ${max} or less',
  VALIDATION_REFERENCE_ID_NUMBER: 'Use up to 10 letters or digits',
  VALIDATION_NUMBER: 'Enter a valid number',
  VALIDATION_GHG_TOTAL_MISMATCH:
    'Total GHG emissions must equal Eec + El + Ep + Etd + Eu - Esca - Eccs - Eccr',
  VALIDATION_ESCA_BONUS_CAP_REQUIRED:
    'Select which Bonus or Cap applies to the claimed Esca saving',

  // ── Contracts ──
  CONTRACTS_TITLE: 'Contracts',
  CONTRACTS_IMPORT: 'Import contracts',
  CONTRACTS_ADD: 'Add contract',
  CONTRACTS_EMPTY_TITLE: 'No contracts found',
  CONTRACTS_EMPTY_DESCRIPTION:
    'No contract has been added yet. Click on button below to add new contract.',
  CONTRACTS_NO_RESULTS_TITLE: 'No matching contracts',
  CONTRACTS_LOAD_ERROR: "Couldn't load this contract. Please try again.",

  // ── Contracts · allocation preference (server `preferred_allocation` enum) ──
  ALLOCATION_FRANCE: 'France',
  ALLOCATION_BELGIUM: 'Belgium',
  ALLOCATION_DENMARK: 'Denmark',
  ALLOCATION_ESTONIA: 'Estonia',
  ALLOCATION_NETHERLANDS: 'Netherlands',
  ALLOCATION_ITALY: 'Italy',
  ALLOCATION_PORTUGAL: 'Portugal',
  ALLOCATION_SINGLE_COUNTING: 'Single counting',
  ALLOCATION_ADVANCED: 'Advanced',

  // ── Contracts · table columns ──

  // ── Contracts · statuses and row actions ──
  CONTRACTS_ACTION_MARK_CLOSED: 'Mark as closed',
  CONTRACTS_ACTION_UNMARK_CLOSED: 'Unmark as closed',
  // ── Contracts · link incoming shipments ──
  LINK_SHIPMENTS_TITLE: 'Link incoming shipments: ${contractId}',
  LINK_SHIPMENTS_STEP_SELECT: 'Select incoming shipments',
  LINK_SHIPMENTS_EMPTY: 'No incoming shipments to link',
  LINK_SHIPMENTS_NONE_TITLE: 'No shipments can be linked',
  LINK_SHIPMENTS_NONE_BODY:
    'No incoming shipment shares this contract’s material, supplier, facility and terminal.',
  LINK_SHIPMENTS_ASSIGN_UNIT_MISSING:
    'Pick a unit this shipment can express before assigning a quantity.',
  LINK_ASSIGN_UNIT_LABEL: 'Select unit for assigned quantities',
  LINK_ASSIGN_QUANTITY: 'Assign quantity',
  PICKER_GROUP_SUGGESTION: 'Suggestion',
  PICKER_GROUP_OTHER: 'Other',
  PICKER_GROUP_LINKED_ORDERS: 'Linked orders',
  PICKER_GROUP_OTHER_ORDERS: 'Other orders',
  PICKER_GROUP_OTHER_SHIPMENTS: 'Other shipments',
  LINK_ASSIGN_OVER_AVAILABLE: 'Cannot be more than the quantity still available',
  LINK_SHIPMENTS_COL_TOTAL_SHIPMENTS_LINKED: 'Total incoming-shipment linked',
  LINK_SHIPMENTS_COL_GHG_SAVINGS: 'GHG savings',

  // Link contracts modal — the mirror wizard, opened from a shipment.
  LINK_CONTRACTS_TITLE: 'Link contracts: ${shipmentId}',
  LINK_CONTRACTS_STEP_SELECT: 'Select contracts',
  LINK_CONTRACTS_EMPTY: 'No contracts to link',
  LINK_CONTRACTS_NONE_TITLE: 'No contracts can be linked',
  LINK_CONTRACTS_NONE_BODY:
    'A contract can only be linked when its material, supplier, site and terminal match the shipment.',
  LINK_CONTRACTS_ASSIGN_UNIT_MISSING: 'Pick a unit for every row you are assigning a quantity to.',
  LINK_ORDERS_TITLE: 'Link orders: ${shipmentId}',
  LINK_SHIPMENTS_FOR_ORDER_TITLE: 'Link outgoing shipment: ${orderNo}',
  LINK_ORDERS_STEP_SELECT: 'Select orders',
  SECTION_ORDER_DETAILS: 'Order details',
  SECTION_SHIPMENT_DETAILS: 'Shipment details',
  LINK_SHIPMENTS_STEP_SELECT_OUTGOING: 'Select outgoing shipments',
  LINK_ORDERS_OVER_ORDER: "Total assign quantity can not be more than order's quantity.",
  LINK_ORDERS_COL_TOTAL_SHIPMENTS_LINKED: 'Total outgoing shipments linked',
  LINK_ORDERS_EMPTY: 'No orders to link',
  LINK_OUTGOING_SHIPMENTS_EMPTY: 'No outgoing shipments to link',
  LINK_ORDERS_NONE_TITLE: 'No orders can be linked',
  LINK_ORDERS_NONE_BODY:
    'Only orders with the same material, facility and customer as this shipment can be linked.',
  LINK_OUTGOING_SHIPMENTS_NONE_TITLE: 'No outgoing shipments can be linked',
  LINK_OUTGOING_SHIPMENTS_NONE_BODY:
    'Only outgoing shipments with the same material, facility and customer as this order can be linked.',
  LINK_ORDERS_OVER_SHIPMENT:
    "Total assign quantity can not be more than outgoing shipment's shipment quantity.",
  LINK_ORDERS_DISCREPANCY_MESSAGE:
    'Dispatch deadline is in ${days} days, but no shipments are linked to this order. ${quantity} quantity is still pending. Link or create shipments now to ensure the order is allocated on time',
  LINK_ORDERS_SAVED: 'Orders linked to shipment successfully.',
  LINK_SHIPMENTS_SAVED: 'Shipments linked to contract successfully.',
  LINK_CONTRACTS_SAVED: 'Contracts linked to shipment successfully.',
  // ─── Receive shipment ───
  RECEIVE_SHIPMENT_TYPE: 'Shipment type',
  RECEIVE_SHIPMENT_TYPE_TO_RECEIVE: 'To receive',
  // "Shipped", not "Shipment": these mirror what the contract has already shipped.
  RECEIVE_SHIPMENT_SAVED: 'Shipment received against the contract successfully.',
  RECEIVE_SHIPMENT_LOAD_ERROR: 'This contract could not be loaded.',

  CONTRACTS_DELETE_TITLE: 'Delete contract',
  CONTRACTS_DELETE_BODY_TITLE: 'Delete contract ${contractId}?',
  CONTRACTS_DELETE_DESCRIPTION: 'This contract and its attachments are removed permanently.',
  // ── Contracts · add/edit form ──

  CONTRACTS_ADD_TITLE: 'Add contract',
  CONTRACTS_EDIT_TITLE: 'Edit contract',
  CONTRACTS_FORM_CONTRACT_ID_PREFIX: 'Contract ID prefix',
  CONTRACTS_FORM_CONTRACT_ID_NUMBER: 'Contract ID number',

  CONTRACTS_FORM_CONTRACTED_QUANTITY_PLACEHOLDER: 'Enter contracted quantity',
  CONTRACTS_FORM_CONTRACTED_QUANTITY_DECLARATION_UNIT:
    'Contracted quantity (${unit}) (Declaration unit)',
  CONTRACTS_FORM_CONTRACTED_QUANTITY_WORKING_UNIT: 'Contracted quantity (${unit}) (Working unit)',
  CONTRACTS_FORM_DENSITY: 'Density (${weightUnit} per ${volumeUnit})',

  FEEDSTOCK_ANNEX_IX_A: 'Annex IX A',
  FEEDSTOCK_ANNEX_IX_B: 'Annex IX B',
  FEEDSTOCK_CROP: 'Crop',

  // ── Contracts · Contract details ──
  CONTRACTS_DETAIL_TAB_SHIPMENTS: 'Linked incoming shipments',
  CONTRACTS_DETAIL_TRANSPORT_NAME: 'Transport name',
  CONTRACTS_DETAIL_ORDER_DETAILS: 'Order Details',
  CONTRACTS_DETAIL_SHIPMENTS_EMPTY_TITLE: 'No incoming shipment linked',
  CONTRACTS_DETAIL_SHIPMENTS_EMPTY_DESCRIPTION:
    'No incoming shipments have been linked yet. Click the button below to link incoming shipments.',
  CONTRACTS_DETAIL_SHIPMENTS_EMPTY_CTA: 'Link incoming shipments',

  // ── Contracts · Contract details · Linked incoming shipments table ──
  CONTRACTS_LINKED_SHIPMENTS_COL_LINKED_CONTRACT: 'Linked contract',
  CONTRACTS_LINKED_SHIPMENTS_COL_SHIPMENT_STATUS: 'Shipment status',
  CONTRACTS_LINKED_SHIPMENTS_COL_ASSIGNED_QTY: 'Assigned qty. (This contract)',
  CONTRACTS_LINKED_SHIPMENTS_COL_ACTUAL_SHIPMENT_QTY: 'Actual shipment quantity',
  CONTRACTS_LINKED_SHIPMENTS_COL_UNASSIGNED_QTY: 'Unassigned qty.',
  CONTRACTS_LINKED_SHIPMENTS_ACTION_ADD_DECLARATION: 'Add declaration',
  CONTRACTS_LINKED_SHIPMENTS_ACTION_VIEW: 'View shipment',
  CONTRACTS_LINKED_SHIPMENTS_REMOVE_LINKAGE_BODY_TITLE:
    'Remove linkage of shipment ${shipmentId} from ${contractId}',

  // ── Contracts · Contract details · Add attachment modal ──
  CONTRACTS_ADD_ATTACHMENT_MODAL_TITLE: 'Add attachment: ${contractId}',

  // ── Contracts · Contract details · Discrepancy modal (shared: contract-level + shipment-level) ──

  // ── Declarations · Add declaration wizard ──
  DECLARATIONS_ADD_TITLE: 'Add declaration',
  DECLARATIONS_ADD_FOR_SHIPMENT_SUBTITLE: 'Add the declarations to the added shipment',
  DECLARATIONS_SHIPMENT_LOAD_ERROR: 'This shipment could not be loaded.',
  DECLARATIONS_STEP_SUMMARY: 'Summary',
  DECLARATIONS_SELECT_FILES_TITLE: 'Select files',
  DECLARATIONS_SELECT_FILES_SUBTITLE: 'Choose list of declarations import to Carboledger platform',
  DECLARATIONS_UPLOAD_HELPER:
    'Maximum no. of files: ${max}, Supported format: ${format} (Maximum file size: 5 MB)',
  DECLARATIONS_CERTIFICATE_CHECKING: 'Verifying certificate…',
  DECLARATIONS_CERTIFICATE_DATES_OUTSIDE:
    'Date of issuance falls outside supplier certificate validity period',
  DECLARATIONS_CERTIFICATE_MARKED_VERIFIED: 'Manually marked as verified',
  DECLARATIONS_CERTIFICATE_NOT_FOUND: 'Certification verification failed. Certificate is not found',
  DECLARATIONS_COL_FILE_NAME: 'File name',
  DECLARATIONS_COL_ERRORS: 'Errors',
  DECLARATIONS_EMPTY_TITLE: 'No files added',
  DECLARATIONS_EMPTY_DESCRIPTION: 'Go back to add declaration files.',
  DECLARATIONS_ERROR_DUPLICATE:
    'This file already exists. If you proceed, the existing file will be ignored.',
  DECLARATIONS_ERROR_TOO_LARGE:
    'The file size exceeds 5 MB. If you proceed, this file will be ignored.',
  DECLARATIONS_ERROR_INVALID_FORMAT:
    'Invalid file format. Only PDF is supported. If you proceed, this file will be ignored',
  DECLARATIONS_SAVE_CHANGES: 'Save changes',
  DECLARATIONS_SAVE_AND_VALIDATE_NEXT: 'Save and validate next declaration',
  DECLARATIONS_RETRY_QUEUED: 'Declaration sent for processing again.',
  DECLARATIONS_SUCCESS_TOAST: '${count} declarations added successfully',
  DECLARATIONS_UPLOAD_PARTIAL: '${count} declarations added, ${skipped} skipped',
  DECLARATIONS_NO_VALID_FILES: 'No valid files to upload. Every selected file has an error.',

  // ── Declarations · Incoming Declarations list ──
  DECLARATIONS_LIST_TITLE: 'Incoming Declarations',
  DECLARATIONS_LIST_BANNER_BOLD: '${count} declaration(s) is processed',
  DECLARATIONS_LIST_BANNER_REGULAR:
    ' and ready to validate. Validate the declarations to add the credits to the system.',
  DECLARATIONS_LIST_VALIDATE: 'Validate declaration(s)',
  DECLARATIONS_LIST_EMPTY_TITLE: 'No declarations found',
  DECLARATIONS_LIST_EMPTY_DESCRIPTION: 'No declaration has been received yet.',
  DECLARATIONS_NO_RESULTS_TITLE: 'No matching declarations',
  DECLARATIONS_COL_REFERENCE_ID: 'Reference ID',
  DECLARATIONS_COL_SHIPPING_FROM: 'Shipping from',
  DECLARATIONS_COL_SURPLUS_QTY: 'Surplus quantity',
  DECLARATIONS_COL_WRITE_OFF_QTY: 'Write off quantity',
  DECLARATIONS_COL_ADJUSTED_QTY: 'Adjusted certified quantity',
  DECLARATIONS_COL_DATE_OF_ISSUANCE: 'Date of issuance',
  DECLARATIONS_COL_DECLARATIONS: 'Declarations',
  DECLARATIONS_COL_VERIFICATION: 'Declaration verification',
  DECLARATIONS_ACTION_RETRY: 'Retry',
  DECLARATIONS_ACTION_VALIDATE: 'Validate',
  DECLARATIONS_ACTION_ADD_SURPLUS_WRITE_OFF: 'Add surplus / write off',
  DECLARATIONS_ACTION_EDIT_SURPLUS_WRITE_OFF: 'Edit surplus / write off',
  DECLARATIONS_DELETE_TITLE: 'Delete declaration',
  DECLARATIONS_DELETE_BODY_TITLE: 'Delete declaration: ${referenceId}',
  DECLARATIONS_DELETE_DESCRIPTION: 'Are you sure you want to delete the declaration?',
  DECLARATIONS_DELETED: 'Declaration deleted successfully.',

  // ── Declarations · Declaration details page ──
  DECLARATIONS_DETAIL_TAB_EMISSION_CALCULATIONS: 'Emission calculations',
  DECLARATIONS_DETAIL_TAB_DECLARATION_DETAILS: 'Declaration details',
  DECLARATIONS_DETAIL_TAB_LINKED_SHIPMENTS: 'Linked incoming shipments',
  DECLARATIONS_DETAIL_TAB_ALLOCATION_DETAILS: 'Allocation details',
  DECLARATIONS_DETAIL_CARD_TITLE: 'Declaration details',
  DECLARATIONS_DETAIL_CARD_MATERIAL: 'Material details',
  DECLARATIONS_DETAIL_CARD_EMISSION: 'Emission details',
  DECLARATIONS_DETAIL_MASS_BALANCE_TITLE: 'Mass balance period details',
  DECLARATIONS_PERIOD_CURRENT: 'Current',
  DECLARATIONS_EMISSIONS_ADD_TITLE: 'Calculate emissions',
  DECLARATIONS_EMISSIONS_EDIT_TITLE: 'Edit emission details',
  DECLARATIONS_EMISSIONS_DELETE_TITLE: 'Delete emission details',
  DECLARATIONS_EMISSIONS_DELETE_DESCRIPTION:
    'Are you sure you want to delete the added emission details? On deleting the details from declarations will be used during allocation and conversion.',
  DECLARATIONS_EMISSIONS_FETCH_DDV: 'Fetch DDV',
  DECLARATIONS_EMISSIONS_TOTAL_TRANSPORT: 'Total transportation emissions (g CO2 eq / MJ)',
  DECLARATIONS_EMISSIONS_TOTAL_TRANSPORT_PLACEHOLDER:
    'Total transportation emissions will be displayed here',
  DECLARATIONS_EMISSIONS_TOTAL_PLACEHOLDER: 'Total emissions will be displayed here',
  FORM_SHIPPING_FROM_PLACEHOLDER: 'Select shipping from',
  DECLARATIONS_EMISSIONS_TOTAL: 'Total emissions (g CO2 eq / MJ)',
  DECLARATIONS_EMISSIONS_FORMULA:
    'Total emissions (E) = Eec + El + Ep + Etd + Eu - Esca - Eccr - Eccs',
  DECLARATIONS_EMISSIONS_SAVED: 'Emission details saved',
  DECLARATIONS_EMISSIONS_DELETED: 'Emission details deleted',
  LINK_SHIPMENTS_FOR_DECLARATION_TITLE: 'Link incoming shipments: ${declarationNo}',
  LINK_SHIPMENTS_TO_DECLARATION_SAVED: 'Shipments linked to declaration successfully.',
  DECLARATIONS_ADD_ATTACHMENT_MODAL_TITLE: 'Add attachment : ${referenceId}',
  DECLARATIONS_LINKED_SHIPMENTS_EMPTY_TITLE: 'No incoming shipment linked',
  DECLARATIONS_LINKED_SHIPMENTS_EMPTY_DESCRIPTION:
    'No incoming shipments has been linked yet. Click on button below to link incoming shipments',
  DECLARATIONS_EMISSIONS_EMPTY_TITLE: 'No calculations found',
  DECLARATIONS_EMISSIONS_EMPTY_DESCRIPTION:
    'Calculate emissions that are not included in the sustainability declaration. These emissions will be used later during the conversion and allocation',
  DECLARATIONS_ALLOCATIONS_EMPTY_TITLE: 'No allocations found',
  DECLARATIONS_ALLOCATIONS_EMPTY_DESCRIPTION:
    'Start fulfilling orders against this declaration to see transaction details here.',

  // ── Declarations · Validate declaration wizard ──
  DECLARATIONS_VALIDATE_STEP_VALIDATE: 'Validate declaration',
  DECLARATIONS_VALIDATE_TITLE: 'Validate declaration : ${referenceId}',
  DECLARATIONS_EDIT_TITLE: 'Edit declaration : ${referenceId}',
  DECLARATIONS_LOAD_ERROR: "Couldn't load this declaration. Please try again.",
  DECLARATIONS_VALIDATE_SUMMARY_GENERAL_INFO: 'General Information',
  DECLARATIONS_VALIDATE_SUMMARY_DECLARATION_DETAILS: 'Declaration details',
  DECLARATIONS_VALIDATE_SUMMARY_MATERIAL_DETAILS: 'Material details',
  DECLARATIONS_VALIDATE_SUMMARY_EMISSION_DETAILS: 'Emission details',
  WORKSPACE_ALL_FACILITIES: 'All sites & facilities',
  WORKSPACE_SITES: 'Sites',
  WORKSPACE_STORAGES: 'Storages',
  WORKSPACE_BACK_TO_BACK_ACCOUNTS: 'Back to back accounts',
  WORKSPACE_SITE_TERMINAL: '${site} / ${terminal}',
  WORKSPACE_SHOW_TERMINALS: 'Show terminals of ${name}',
  ACTION_MARK_AS_VERIFIED: 'Mark as verified',
  ACTION_UNMARK_AS_VERIFIED: 'Unmark as verified',
  PDF_VIEWER_NO_FILE: 'No PDF file specified.',
  FIELD_SUPPLIER_CERTIFICATE_NUMBER: 'Supplier Certificate number',
  FIELD_DECLARATION_VERIFICATION_STATUS: 'Declaration verification status',
  FIELD_NOTE: 'Note',
  SECTION_BASIC_INFORMATION: 'Basic information',
  SECTION_ALLOCATION_RULES: 'Allocation rules',
  SECTION_SUSTAINABILITY_DECLARATION_DETAILS: 'Sustainability Declaration details',
  SECTION_GENERAL_INFORMATION: 'General information',
  SECTION_CERTIFICATION_SCOPE: 'Scope of certification of raw material',
  SECTION_GHG_EMISSION_DETAILS: 'GHG emission details',
  SECTION_GHG_EMISSION_SAVING: 'GHG emission savings',
  SECTION_VOLUNTARY_ADD_ONS: 'Voluntary Add-Ons',

  FIELD_TYPE_OF_PRODUCT: 'Type of product',
  FORM_SELECT_TYPE_OF_PRODUCT: 'Select the type of product',
  FIELD_TYPE_OF_RAW_MATERIAL: 'Type of raw material',
  FORM_SELECT_TYPE_OF_RAW_MATERIAL: 'Select the type of raw material',
  FORM_ADDITIONAL_INFORMATION: 'Additional information (Optional)',
  FORM_ADDITIONAL_INFORMATION_PLACEHOLDER: 'Enter additional information',

  FIELD_COUNTRY_OF_BIOFUEL_PRODUCTION: 'Country of biofuel production',
  FIELD_ENERGY_CONTENT: 'Energy content (MJ)',
  FORM_ENERGY_CONTENT_PLACEHOLDER: 'Enter energy content',
  FIELD_EU_RED_COMPLIANT_MATERIAL: 'EU RED Compliant material',
  FORM_ISCC_COMPLIANT_MATERIAL: 'ISCC Compliant material (Optional)',
  FORM_CHAIN_OF_CUSTODY_OPTION: 'Chain of custody option (Optional)',
  CHAIN_OF_CUSTODY_MASS_BALANCE: 'Mass balance',
  CHAIN_OF_CUSTODY_PHYSICAL_SEGREGATION: 'Physical segregation',
  FIELD_START_DATE_OF_BIOFUEL_PRODUCTION: 'Start date of biofuel production',
  FORM_START_DATE_OF_BIOLIQUID_USE:
    'If applicable, start date of bioliquid / biomass fuel use (Optional)',

  FIELD_SUSTAINABILITY_CRITERIA_COMPLIANCE:
    'Raw material complies with the relevant sustainability criteria (Art. 29(2) - (7) RED III',
  FORM_INTERMEDIATE_CROP:
    'Agricultural biomass was cultivated as intermediate crop (If applicable)',
  FORM_LOW_ILUC_RISK_FEEDSTOCK:
    'Agricultural biomass additionally fulfills the measures for low ILUC risk feedstocks (If applicable)',
  FIELD_WASTE_OR_RESIDUE_DEFINITION:
    'Raw material meets the definition of waste or residue according to the RED III',
  FORM_WASTE_OR_BY_PRODUCT_PERMIT_NUMBER:
    'If applicable, please specify waste or animal by-product permit number',
  FORM_PERMIT_NUMBER_PLACEHOLDER: 'Enter permit number',
  FIELD_PRODUCTION_SUPPORT_RECEIVED:
    'Was support for the production of the fuel or fuel precursor received?',
  FORM_SUPPORT_NATURE_AND_SCHEME: 'If yes, please specify support nature and scheme',

  FIELD_DEFAULT_GHG_VALUE_APPLIED: 'Default value according to RED III applied',
  FIELD_TOTAL_GHG_EMISSIONS: 'Total GHG emissions (gCO2 e / MJ)',
  FIELD_EEC_EMISSIONS:
    'Eec - Emissions from the extraction or cultivation of raw materials (gCO2 e / MJ)',
  FIELD_EL_EMISSIONS: 'El - Emissions from land-use change (gCO2 e / MJ)',
  FIELD_EP_EMISSIONS: 'Ep - Emissions from processing (gCO2 e / MJ)',
  FIELD_ETD_EMISSIONS: 'Etd - Emissions from transport and distribution (gCO2 e / MJ)',
  FIELD_EU_EMISSIONS: 'Eu - Emissions from the fuel in use (gCO2 e / MJ)',
  FIELD_ESCA_EMISSIONS: 'Esca - Emission savings from improved carbon accumulation (gCO2 e / MJ)',
  FIELD_ECCS_EMISSIONS: 'Eccs - Emission savings from carbon capture and storage (gCO2 e / MJ)',
  FIELD_ECCR_EMISSIONS: 'Eccr - Emission savings from carbon capture and replacement (gCO2 e / MJ)',
  FORM_ENTER_EMISSIONS_PLACEHOLDER: 'Enter the emissions',
  FORM_EEC_EMISSIONS_OPTIONAL:
    'Eec - Emissions from the extraction or cultivation of raw materials (g CO2 eq / MJ) (Optional)',
  FORM_EEC_EMISSIONS_PLACEHOLDER: 'Enter cultivation emissions',
  FORM_EP_EMISSIONS_OPTIONAL: 'Ep - Emissions from processing (g CO2 eq / MJ) (Optional)',
  FORM_EP_EMISSIONS_PLACEHOLDER: 'Enter processing emissions',
  FORM_ETD_EMISSIONS_OPTIONAL:
    'Etd - Emissions from transport and distribution (gCO2 e / MJ) (Optional)',
  FORM_ETD_EMISSIONS_PLACEHOLDER: 'Enter transport and distribution emissions',
  FORM_SHIPPING_FROM_OPTIONAL: 'Shipping from (Optional)',
  FORM_SELECT_ROUTE_OPTIONAL: 'Select route (Optional)',
  FORM_CALORIFIC_VALUE: 'Calorific value (MJ / kg)',
  FORM_ALLOCATED_HEAT: 'Allocated heat (gCO2 e / MJ) (Optional)',
  FORM_ALLOCATED_HEAT_PLACEHOLDER: 'Enter the allocated heat',
  FORM_ALLOCATED_ELECTRICITY: 'Allocated electricity (gCO2 e / MJ) (Optional)',
  FORM_ALLOCATED_ELECTRICITY_PLACEHOLDER: 'Enter the allocated electricity',
  FORM_ESCA_BONUS_CAP: 'Esca: Specify which Bonus or Cap applies to any claimed Esca saving',
  ESCA_BONUS_CAP_NOT_CLAIMED: 'Esca not claimed',
  ESCA_BONUS_CAP_MANURE_BONUS: 'Manure Bonus ( 45 gCO2 eq / MJ manure)',
  ESCA_BONUS_CAP_NO_CAP_BEFORE_2013: 'No cap (Biomass harvested before 29.12.2013)',
  ESCA_BONUS_CAP_BIOFUEL_AFTER_2023: '25 gCO2 eq / MJ Biofuel (Biomass harvested after 29.12.2023)',
  ESCA_BONUS_CAP_BIOCHAR_USE: '45 gCO2 eq / MJ Biofuel (due to the use of Biochar)',
  ESCA_BONUS_CAP_PRIOR_ESCA_CLAIMS:
    '45 gCO2 eq / MJ Biofuel (due to prior Esca claims on the cultivation area)',
  FORM_NUTS2_AREA: 'If applicable, please specify the NUTS2 area (Optional)',
  FORM_NUTS2_AREA_PLACEHOLDER: 'Enter the NUTS2 area',

  FIELD_BIOFUELS_TRANSPORT_SAVING: 'Biofuels for transport',
  FIELD_BIOLIQUIDS_ELECTRICITY_SAVING:
    'Bioliquids/ Biomass fuels for the production of electricity',
  FIELD_BIOMASS_OUTERMOST_REGIONS_SAVING:
    'Biomass fuels for the production of electricity in the outermost regions',
  FIELD_BIOLIQUIDS_HEAT_SAVING:
    'Bioliquids / Biomass fuels for the production of useful heat, as well as for the production of energy for heating and / or cooling',
  FIELD_BIOMASS_COAL_SUBSTITUTION_SAVING:
    'Biomass fuels for the production of useful heat, in which a direct physical substitution of coal can be demonstrated',
  FORM_BIOFUELS_TRANSPORT_SAVING: 'Biofuels for transport (%)',
  FORM_BIOFUELS_TRANSPORT_SAVING_PLACEHOLDER: 'Enter the biofuels for transport saving in %',
  FORM_BIOLIQUIDS_ELECTRICITY_SAVING:
    'Bioliquids/ Biomass fuels for the production of electricity (%)',
  FORM_BIOLIQUIDS_ELECTRICITY_SAVING_PLACEHOLDER:
    'Enter the bioliquids / biomass fuels for the production of electricity saving in %',
  FORM_BIOMASS_OUTERMOST_REGIONS_SAVING:
    'Biomass fuels for the production of electricity in the outermost regions (%)',
  FORM_BIOMASS_OUTERMOST_REGIONS_SAVING_PLACEHOLDER:
    'Enter the biomass fuels for the production of electricity saving in %',
  FORM_BIOLIQUIDS_HEAT_SAVING:
    'Bioliquids / Biomass fuels for the production of useful heat, as well as for the production of energy for heating and / or cooling (%)',
  FORM_BIOLIQUIDS_HEAT_SAVING_PLACEHOLDER:
    'Enter the bioliquids / biomass fuels for the production of useful heat saving in %',
  FORM_BIOMASS_COAL_SUBSTITUTION_SAVING:
    'Biomass fuels for the production of useful heat, in which a direct physical substitution of coal can be demonstrated (%)',
  FORM_BIOMASS_COAL_SUBSTITUTION_SAVING_PLACEHOLDER:
    'Enter the biomass fuels for the production of useful heat saving in %',

  FORM_FOOD_SECURITY_STANDARD: 'Food Security Standard (FSS) - 202 - 04 (Optional)',
  FORM_EU_DEFORESTATION_REGULATION: 'EU Deforestation Regulation (EUDR) - 202 - 09 (Optional)',
  FORM_NON_GMO_FOOD_FEED: 'Non-GMO for Food and Feed - 205 - 03 (Optional)',
  FORM_NON_GMO_TECHNICAL_MARKETS: 'Non-GMO for Technical Markets - 205 - 04 (Optional)',

  // ── Edit declaration wizard · shared step vocabulary ──
  FIELD_NAME: 'Name',
  FIELD_ADDRESS: 'Address',
  SECTION_SUPPLIER: 'Supplier',
  SECTION_RECIPIENT: 'Recipient',

  // ── Shared · Discrepancy modal (components/common/Discrepancy) ──
  DISCREPANCY_MODAL_TITLE: 'Discrepancies: ${referenceId}',
  DISCREPANCY_GO_BACK: 'Close',
  DISCREPANCY_EMPTY_VALUE: '—',

  // ── Shared · Surplus/write-off modal (components/common/SurplusWriteoffModal) ──
  SURPLUS_WRITEOFF_TYPE_SURPLUS: 'Surplus',
  SURPLUS_WRITEOFF_TYPE_WRITE_OFF: 'Write off',
  SURPLUS_WRITEOFF_QUANTITY_EXCEEDS_AVAILABLE:
    'Insufficient quantity. The entered quantity exceeds the available quantity.',
  SURPLUS_WRITEOFF_SAVED: 'Surplus / write-off saved successfully.',

  // ── Shared · Add attachment modal + attachments table (components/common/AddAttachmentModal) ──
  ATTACHMENT_INFO:
    'Documents added here will be visible in all the linked shipments and associated declarations',
  ATTACHMENT_BILL_OF_LADING: 'Bill of lading',
  ATTACHMENT_INVOICE: 'Invoice',
  ATTACHMENT_OTHER_DOCUMENTS: 'Other documents',
  ATTACHMENT_UPLOAD: 'Upload document',
  ATTACHMENT_HINT_SINGLE: 'Supported format: .pdf, .jpeg, .jpg (Maximum file size: 5 MB)',
  ATTACHMENT_HINT_MULTIPLE:
    'Supported format: .pdf, .jpeg, .jpg (Maximum no. of files: 5, Total file size should not exceed 25 MB)',
  ATTACHMENT_ADD: 'Add',
  ATTACHMENT_ERROR_FILE_SIZE: '${name}: file size should not exceed 5 MB',
  ATTACHMENT_ERROR_TOTAL_SIZE: 'Total file size should not exceed 25 MB',
  ATTACHMENT_ERROR_MAX_FILES: 'Maximum number of files should not exceed 5',
  ATTACHMENT_ADD_SUCCESS: 'Documents added successfully',
  ATTACHMENT_REMOVE_SUCCESS: 'Document removed successfully',
  ATTACHMENT_DOWNLOAD_ERROR: '${name} could not be downloaded. Please try again.',
  ATTACHMENT_ERROR_FORMAT: '${name}: invalid file format. Only PDF, JPEG and JPG are supported.',
  CONTRACTS_SAVED: 'Contract saved successfully.',

  CONTRACTS_DELETED: 'Contract deleted successfully.',
  CONTRACTS_STATUS_UPDATED: 'Contract status updated successfully.',
  CONTRACTS_LINKED_SHIPMENTS_REMOVED: 'Shipment linkage removed.',
  ATTACHMENT_COL_NAME: 'Name',
  ATTACHMENT_COL_LAST_UPDATED_ON: 'Last updated on',
  ATTACHMENT_ACTION_DOWNLOAD: 'Download',
  // ── Orders (Outbounds) ──
  ORDERS_TITLE: 'Orders',
  ORDERS_ADD: 'Add order',
  ORDERS_IMPORT: 'Import orders',
  ORDERS_EMPTY_TITLE: 'No orders found',
  ORDERS_EMPTY_DESCRIPTION: 'No order has been added yet. Click on button below to add new order.',
  ORDERS_NO_RESULTS_TITLE: 'No matching orders',

  // ── Orders · statuses (server ORDER_STATUS enum) ──

  // ── Orders · table columns ──
  ORDERS_COL_ORDER_NO: 'Order no.',
  ORDERS_COL_ALLOCATED_GHG_SAVINGS: 'Allocated GHG emission savings (avg.)',
  ORDERS_COL_REMAINING_TO_SHIP: 'Remaining to ship quantity',
  ORDERS_COL_REMAINING_TO_ALLOCATE: 'Remaining to allocate quantity',
  ORDERS_COL_TOLERANCE: 'Tolerance (+/-)',
  ORDERS_COL_MAX_GHG_EMISSIONS: 'Max. GHG emissions',
  ORDERS_COL_MIN_GHG_SAVINGS: 'Min. GHG emission savings',

  // ── Orders · filters and row actions ──

  // ── Order details page ──
  ORDERS_DETAIL_LOAD_ERROR: "Couldn't load this order. Please try again.",
  ORDERS_DETAIL_ORDER_DETAILS: 'Order Details',
  ORDERS_DETAIL_TAB_SHIPMENTS: 'Linked outgoing shipment',
  ORDERS_DETAIL_TAB_ALLOCATIONS: 'Allocation details',
  ORDERS_DETAIL_COL_ALLOCATED_GHG_SAVING: 'Allocated GHG emission saving',
  ORDERS_DETAIL_COL_ALLOCATED_DATE: 'Allocated date',
  ORDERS_DETAIL_COL_DECLARATIONS: 'Declarations',
  ORDERS_COL_ASSIGNED_QUANTITY: 'Assigned quantity',
  ORDERS_COL_ASSIGN_QUANTITY: 'Assign quantity',
  ORDERS_DETAIL_SHIPMENTS_EMPTY_TITLE: 'No outgoing shipment linked',
  ORDERS_DETAIL_SHIPMENTS_EMPTY_DESCRIPTION:
    'No outgoing shipment has been linked yet. Click on button below to link outgoing shipments',
  ORDERS_DETAIL_SHIPMENTS_EMPTY_CTA: 'Link outgoing shipments',
  ORDERS_DETAIL_ALLOCATIONS_EMPTY_TITLE: 'No associated allocations has been made',
  ORDERS_DETAIL_ALLOCATIONS_EMPTY_DESCRIPTION:
    'No associated allocations has been made. Once allocated, the details will be available here',
  ORDERS_DETAIL_ALLOCATIONS_LOAD_ERROR: "Couldn't load allocation details. Please try again.",
  ORDERS_DETAIL_TOTAL_SHIPPED_QUANTITY: 'Total shipped quantity',
  ORDERS_DETAIL_REMAINING_TO_SHIP_IN_UNIT: 'Remaining to ship quantity (In ${unit} unit)',
  ORDERS_DETAIL_ALLOCATED_QUANTITY: 'Total allocated quantity',
  ORDERS_DETAIL_REMAINING_TO_ALLOCATE: 'Remaining to allocate quantity',
  ORDERS_DETAIL_STATUS_ACTIVE: 'Active',
  ORDERS_DETAIL_STATUS_CLOSED: 'Closed',
  ORDERS_DETAIL_STATUS_CANCELLED: 'Cancelled',
  ORDERS_DETAIL_DISCREPANCY_MESSAGE:
    'This order has not been shipped and its dispatch date is approaching.',

  // ── Order form (Add / Edit) ──
  ORDERS_FORM_ORDER_ID_PREFIX: 'Order no. prefix',
  ORDERS_FORM_ORDER_ID_NUMBER: 'Order no. number',
  ORDERS_FORM_TOLERANCE_OPTIONAL: 'Tolerance (+/-) (Optional)',
  ORDERS_FORM_TOLERANCE_PLACEHOLDER: 'Enter tolerance',
  ORDERS_FORM_DISPATCH_BY: 'Dispatch by',
  ORDERS_FORM_PREFERENCES_TITLE: 'Preferences',
  ORDERS_FORM_PREFERENCES_DESCRIPTION:
    'Select the checkboxes for the fields you want to make mandatory. Only inbounds that match all selected preferences will be available when fulfilling the order.',
  ORDERS_FORM_MAX_GHG_EMISSIONS: 'Max. GHG emissions (g CO2 e / MJ) (Optional)',
  ORDERS_FORM_MAX_GHG_EMISSIONS_PLACEHOLDER: 'Enter the maximum GHG emissions',
  ORDERS_FORM_MIN_GHG_SAVINGS: 'Min. GHG emission savings (Optional)',
  ORDERS_FORM_MIN_GHG_SAVINGS_PLACEHOLDER: 'Enter the minimum GHG emission savings',
  ORDERS_FORM_MARK_AS_MANDATORY: 'Mark as mandatory',
  ORDERS_FORM_REQUIRED_FIELDS_NOTE: 'Fields marked with an asterisk (*) are required fields',
  ORDERS_SAVED: 'Order saved successfully.',
  ORDERS_EDIT_TITLE: 'Edit order',
  ORDERS_UPDATED: 'Order updated successfully.',
  ORDERS_LOAD_ERROR: "Couldn't load this order. Please try again.",
  ORDERS_DELETED: 'Order deleted successfully.',
  ORDERS_DELETE_TITLE: 'Delete order',
  ORDERS_DELETE_BODY_TITLE: 'Delete order ${orderNo}?',
  ORDERS_DELETE_DESCRIPTION: 'This order is removed permanently.',
  ORDERS_QUANTITY_BELOW_SHIPPED:
    'Contracted quantity cannot be less than the shipped quantity (${quantity} ${unit}).',
  ORDERS_QUANTITY_BELOW_ALLOCATED:
    'Contracted quantity cannot be less than the allocated quantity (${quantity} ${unit}).',

  // ── Update shipment (Orders ▸ fulfillment) ──
  ORDERS_UPDATE_SHIPMENT_TITLE: 'Update shipment: ${orderNo}',
  ORDERS_UPDATE_SHIPMENT_DESCRIPTION:
    'To fulfill this order, a new shipment will be created using the details already provided in the order. Any available information will be automatically carried over. Please review and complete the fields below to provide any missing details required to successfully create the shipment.',

  // ── Fulfill order (Orders ▸ fulfillment) ──
  ORDERS_FULFILL_LOAD_ERROR: "Couldn't load this order. Please try again.",
  ORDERS_FULFILL_SECTION_ALLOCATIONS: 'Allocations details',
  ORDERS_FULFILL_SECTION_OUTGOING_SHIPMENT: 'Outgoing shipment',
  FIELD_SHIPMENT_OPTION: 'Shipment option',
  FORM_SELECT_SHIPMENT_OPTION: 'Select outgoing shipment option',
  ORDERS_FULFILL_SHIPMENT_OPTION_CREATE_NEW: 'Create new outgoing shipment',
  ORDERS_FULFILL_SHIPMENT_OPTION_SELECT_EXISTING: 'Select existing outgoing shipment',
  ORDERS_FULFILL_SHIPMENT_OPTION_ADD_LATER: 'Add shipment details later',
  FIELD_RETIRE_CREDITS: 'Retire credits (Optional)',
  FORM_SELECT_RETIRE_CREDITS: 'Select whether you want to retire the credits',
  ORDERS_FULFILL_QUANTITY_MIN: 'Shipment quantity should be greater than 0',
  ORDERS_FULFILL_QUANTITY_EXCEEDS_ALLOCATE:
    'Shipment quantity cannot be more than the remaining to allocate quantity',
  ORDERS_FULFILL_QUANTITY_EXCEEDS_SHIP:
    'Shipment quantity cannot be more than the remaining to ship quantity',
  ORDERS_FULFILL_LINK_EXISTING_SHIPMENT: 'Link existing outgoing shipment',
  ORDERS_FULFILL_SELECT_OUTGOING_SHIPMENT: 'Select outgoing shipment',
  ORDERS_FULFILL_OUTGOING_SHIPMENTS_EMPTY: 'No eligible outgoing shipments found.',
  ORDERS_FULFILL_SECTION_ALLOCATE_CREDIT: 'Allocate credit',
  ORDERS_FULFILL_SELECT_INBOUND_PROMPT: 'Select inbound to fulfill the order',
  ORDERS_FULFILL_SELECT_INBOUND: 'Select inbound',
  ORDERS_FULFILL_SOLD_TO_REQUIRED: 'Select a Sold to on the order before allocating credit.',
  ORDERS_FULFILL_SELECT_INBOUND_EMPTY: 'No eligible inbounds found.',
  ORDERS_FULFILL_CERTIFIED_OVER_BALANCE: 'Certified quantity cannot be more than balance quantity',
  ORDERS_FULFILL_TOTAL_CERTIFIED_QUANTITY: 'Total certified quantity',
  FORM_CERTIFIED_QUANTITY_PLACEHOLDER: 'Enter certified quantity',
  ORDERS_FULFILL_CONTRACTED_QUANTITY_TILE: 'Contracted quantity (In ${unit} unit)',
  ORDERS_FULFILL_REMAINING_TO_SHIP_TILE: 'Remaining to ship (In ${unit} unit)',
  ORDERS_FULFILL_REMAINING_TO_ALLOCATE_TILE: 'Remaining to allocate (In ${unit} unit)',
  ORDERS_FULFILL_SHIPMENT_QUANTITY_TILE: 'Shipment quantity (In ${unit} unit)',
  ORDERS_FULFILL_ALLOCATED_QUANTITY_TILE: 'Allocated quantity (In ${unit} unit)',
  OUTGOING_SHIPMENTS_DETAIL_ALLOCATED_TILE: 'Total allocated quantity (In ${unit} unit)',
  OUTGOING_SHIPMENTS_DETAIL_REMAINING_TO_ALLOCATE_TILE:
    'Remaining to allocate quantity (In ${unit} unit)',
  ORDERS_FULFILL_TOTAL_EXCEEDS_PENDING:
    'Total certified quantity cannot be more than the pending quantity remaining on the order.',
  ORDERS_FULFILL_MIXED_UNITS_ERROR:
    'All selected inbounds must use the same unit before you can fulfill this order — switch them to one unit above.',
  ORDERS_FULFILL_NO_INBOUND_SELECTED_ERROR:
    'Please select at least one inbound to allocate credits before saving.',
  ORDERS_FULFILL_TRANSACTION_ID_PREFIX: 'Transaction ID prefix',
  ORDERS_FULFILL_TRANSACTION_ID_NUMBER: 'Transaction ID number',
  ORDERS_FULFILL_REQUIRED_FIELDS_NOTE: 'Fields marked with an asterisk (*) are required fields',
  TRANSACTIONS_ACTION_VIEW_DECLARATION: 'View declaration',
  TRANSACTIONS_ACTION_VIEW_ATTACHMENTS: 'View attachments',
  TRANSACTIONS_ATTACHMENT_TYPE: 'Attachment type',
  TRANSACTIONS_ATTACHMENTS_TITLE: 'Attachments for ${transactionId}',
  TRANSACTIONS_ATTACHMENTS_NOTE:
    'Files attached to this transaction, and to the inbound batch it drew from.',
  TRANSACTIONS_ATTACHMENTS_EMPTY: 'No attachments on this transaction',
  TRANSACTIONS_TITLE: 'Transactions',
  TRANSACTIONS_COL_SERIAL_NO: 'S. No.',
  TRANSACTIONS_COL_DECLARATION_NO: 'Declaration no.',
  TRANSACTIONS_COL_ASSOCIATED_ID: 'Associated ID',
  TRANSACTIONS_COL_ASSOCIATED_SITE: 'Associated site',
  TRANSACTIONS_COL_TYPE: 'Type',
  TRANSACTIONS_COL_BALANCE: 'Balance',
  TRANSACTIONS_COL_TRANSACTED_BY: 'Transacted by',
  TRANSACTIONS_TYPE_INCOMING_DECLARATION: 'Incoming declaration',
  TRANSACTIONS_TYPE_SURPLUS: 'Surplus',
  TRANSACTIONS_TYPE_WRITE_OFF: 'Write-off',
  TRANSACTIONS_TYPE_OUTGOING_DECLARATION: 'Outgoing declaration',
  TRANSACTIONS_TYPE_REVERTED: 'Reverted',
  TRANSACTIONS_TOOLTIP_MASS_BALANCE_PERIOD:
    'The reporting period during which this allocation was executed.',
  TRANSACTIONS_EMPTY_TITLE: 'No transaction has been made',
  TRANSACTIONS_EMPTY_DESCRIPTION:
    'Every inbound and outbound movement will appear here as it happens.',
  TRANSACTIONS_NO_RESULTS_TITLE: 'No transactions match your filters',
  TRANSACTIONS_NO_RESULTS_DESCRIPTION: 'Try a different search or clear the filters.',
  FIELD_TRANSACTION_DATE: 'Transaction date',
  ORDERS_FULFILL_DEADLINE_WARNING:
    "Deadline for 'Date of dispatch' is in ${days} days. ${pendingQty} quantity is still pending. Link or create shipments to ensure on-time Allocations.",
  ORDERS_FULFILL_TRANSPORTATION_NOTE:
    "Note: Transportation emissions between your site and the customer's site are not accounted for at this step. When generating the declaration, you will have the option to add relevant transportation emissions, which may affect the total emissions.",
  ORDERS_FULFILL_SUCCESS_TITLE: 'Order allocated successfully',
  ORDERS_FULFILL_SUCCESS_BODY:
    'Order has been allocated successfully. Do you want to proceed to generating declaration for this allocation?',
  ORDERS_FULFILL_SAVED_FLASH: 'Order fulfilled successfully',
  ACTION_BACK_TO_OUTBOUNDS: 'Back to Outbounds',

  // ── Outgoing shipments (Outbounds) ──
  OUTGOING_SHIPMENTS_TITLE: 'Outgoing shipments',
  OUTGOING_SHIPMENTS_ADD: 'Add outgoing shipment',
  OUTGOING_SHIPMENTS_IMPORT: 'Import outgoing shipments',
  OUTGOING_SHIPMENTS_EMPTY_TITLE: 'No outgoing shipments found',
  OUTGOING_SHIPMENTS_EMPTY_DESCRIPTION:
    'No outgoing shipment has been added yet. Click on button below to add new shipment.',
  OUTGOING_SHIPMENTS_NO_RESULTS_TITLE: 'No matching outgoing shipments',
  OUTGOING_SHIPMENTS_SAVED_FLASH: 'Outgoing shipment saved successfully.',
  OUTGOING_SHIPMENTS_DELETED: 'Shipment deleted successfully.',
  OUTGOING_SHIPMENTS_DELETE_TITLE: 'Delete shipment',
  OUTGOING_SHIPMENTS_DELETE_BODY_TITLE: 'Delete shipment ${shipmentId}?',
  OUTGOING_SHIPMENTS_DELETE_DESCRIPTION:
    'This shipment is removed permanently and its orders are unlinked.',
  OUTGOING_SHIPMENTS_UPDATED: 'Shipment updated successfully',
  OUTGOING_SHIPMENTS_EDIT_TITLE: 'Edit outgoing shipment',
  OUTGOING_SHIPMENTS_LOAD_ERROR: 'This outgoing shipment could not be loaded.',
  OUTGOING_SHIPMENTS_WORKING_UNIT_NO_CORRELATION:
    'Working unit is unavailable — no conversion factor is set for this material in Account setup.',
  OUTGOING_SHIPMENTS_QUANTITY_BELOW_ASSIGNED:
    'Shipment quantity cannot be reduced below the total assigned quantity (${quantity} ${unit}).',

  // ── Outgoing shipments · statuses (server outgoing_shipment_status enum) ──
  OUTGOING_SHIPMENTS_STATUS_PENDING: 'Pending',
  OUTGOING_SHIPMENTS_STATUS_PARTIALLY_ALLOCATED: 'Partially allocated',
  OUTGOING_SHIPMENTS_STATUS_ALLOCATED: 'Allocated',
  OUTGOING_SHIPMENTS_STATUS_CANCELLED: 'Cancelled',

  // ── Outgoing shipments · table columns ──
  OUTGOING_SHIPMENTS_COL_LINKED_ORDERS: 'Linked orders',
  OUTGOING_SHIPMENTS_COL_REMAINING_TO_ALLOCATE: 'Remaining to allocate',

  // ── Outgoing shipments · row actions ──
  OUTGOING_SHIPMENTS_ACTION_LINK_ORDERS: 'Link orders',

  // ── Outgoing shipments · detail page ──
  UPDATE_SHIPMENT_TITLE: 'Update shipment: ${orderId}',
  UPDATE_SHIPMENT_HEADING: 'Create new outgoing shipment',
  UPDATE_SHIPMENT_DESCRIPTION:
    'To fulfill this order, a new shipment will be created using the details already provided in the order. Any available information will be automatically carried over. Please review and complete the fields below to provide any missing details required to successfully create the shipment.',
  OUTGOING_SHIPMENTS_DETAIL_TAB_OVERVIEW: 'Outgoing shipment details',
  OUTGOING_SHIPMENTS_DETAIL_TAB_ORDERS: 'Linked orders',
  OUTGOING_SHIPMENTS_DETAIL_TAB_ALLOCATIONS: 'Allocation details',
  OUTGOING_SHIPMENTS_DETAIL_COL_ALLOCATED_GHG_SAVINGS: 'Allocated GHG emission savings (avg.)',
  OUTGOING_SHIPMENTS_DETAIL_COL_ASSIGNED_THIS_SHIPMENT: 'Assigned quantity (This shipment)',
  OUTGOING_SHIPMENTS_FULFILLED: 'Shipment fulfilled successfully.',
  OUTGOING_SHIPMENTS_FULFILL_LOAD_ERROR: "Couldn't load this shipment. Please try again.",
  OUTGOING_SHIPMENTS_FULFILL_SECTION_ORDER: 'Order selection',
  OUTGOING_SHIPMENTS_FULFILL_SELECT_ORDER_PROMPT: 'Select order to allocate credits',
  OUTGOING_SHIPMENTS_FULFILL_SELECT_ORDER: 'Select order',
  OUTGOING_SHIPMENTS_FULFILL_ORDERS_EMPTY: 'No eligible orders found.',
  OUTGOING_SHIPMENTS_FULFILL_ORDER_REQUIRED: 'Select an order before saving.',
  OUTGOING_SHIPMENTS_FULFILL_ORDER_REQUIRED_FOR_CREDIT: 'Select an order before allocating credit.',
  OUTGOING_SHIPMENTS_DETAIL_DISCREPANCY_MESSAGE:
    'No orders are linked to this shipment and its dispatch date is approaching.',
  OUTGOING_SHIPMENTS_DETAIL_ORDERS_EMPTY_TITLE: 'No orders have been linked yet',
  OUTGOING_SHIPMENTS_DETAIL_ORDERS_EMPTY_DESCRIPTION:
    'Link an order to assign this shipment’s quantity to it.',
  OUTGOING_SHIPMENTS_DETAIL_ALLOCATIONS_EMPTY_TITLE: 'No transactions yet',
  OUTGOING_SHIPMENTS_DETAIL_ALLOCATIONS_EMPTY_DESCRIPTION:
    'No transactions have been recorded yet. Once the shipment is fulfilled, the details will be available here',

  // ── Allocations (Outbounds) ──
  ALLOCATIONS_TITLE: 'Allocations',
  ALLOCATIONS_EMPTY_TITLE: 'No shipment has been fulfilled',
  ALLOCATIONS_EMPTY_DESCRIPTION:
    'No shipment has been fulfilled. You will need to fulfill the shipments to generate the declarations.',
  ALLOCATIONS_NO_RESULTS_TITLE: 'No matching allocations',
  ALLOCATIONS_NO_RESULTS_DESCRIPTION: 'Try clearing your filters.',
  ALLOCATIONS_BULK_GENERATE_DECLARATIONS: 'Generate declarations',

  // ── Allocations · statuses (rendered server-side by resolveApprovalStatus) ──
  ALLOCATIONS_STATUS_PENDING_DECLARATION: 'Pending declaration',
  ALLOCATIONS_STATUS_PENDING_SHIPMENT: 'Pending shipment',
  ALLOCATIONS_STATUS_DECLARATION_GENERATED: 'Declaration generated',
  ALLOCATIONS_STATUS_DECLARATION_UPDATED: 'Declaration updated',
  ALLOCATIONS_STATUS_DECLARATION_REJECTED: 'Declaration rejected',
  ALLOCATIONS_STATUS_CREDITS_RETIRED: 'Credits retired',
  ALLOCATIONS_STATUS_REVOKED: 'Revoked',

  // ── Allocations · table columns ──
  ALLOCATIONS_COL_TRANSACTION_ID: 'Transaction ID',
  ALLOCATIONS_COL_DECLARATION_NO: 'Declaration no.',
  ALLOCATIONS_COL_INTERNAL_TRANSFER: 'Internal transfer',
  ALLOCATIONS_COL_SEND_TO: 'Send to',
  ALLOCATIONS_COL_SHIPPING_TO: 'Shipping to (sites)',
  ALLOCATIONS_COL_ALLOCATION_DATE: 'Allocation date',
  ALLOCATIONS_COL_CERTIFIED_QUANTITY: 'Certified quantity',
  ALLOCATIONS_COL_MASS_BALANCE_PERIOD: 'Mass balance period',
  ALLOCATIONS_COL_REFERENCE: 'Reference',
  ALLOCATIONS_COL_ASSOCIATED_DECLARATION_NO: 'Associated inbound declaration no.',
  ALLOCATIONS_COL_DECLARATIONS: 'Declarations',
  ALLOCATIONS_COL_TRANSACTED_BY: 'Transacted by',
  ALLOCATIONS_COL_GHG_EMISSION_SAVINGS: 'GHG emissions savings',
  ALLOCATIONS_COL_ALLOCATED_QUOTA: 'Allocated quota',
  ALLOCATIONS_COL_BALANCE_QUANTITY: 'Balance quantity',
  ALLOCATIONS_COL_GHG_SAVINGS: 'GHG savings',

  // ── Allocations · filters and row actions ──
  ALLOCATIONS_DAYS_LEFT: '${days} days left',
  ALLOCATIONS_ACTION_GENERATE_DECLARATION: 'Generate declaration',
  ALLOCATIONS_ACTION_REVOKE: 'Revoke',
  ALLOCATIONS_ACTION_VIEW_DECLARATION: 'View generated declaration',
  ALLOCATIONS_ACTION_MARK_REJECTED: 'Mark as rejected',
  ALLOCATIONS_ACTION_DOWNLOAD_DECLARATION: 'Download declaration',
  ALLOCATIONS_ACTION_EDIT_DECLARATION: 'Edit declaration',
  ALLOCATIONS_ACTION_UPDATE_SHIPMENT_DETAILS: 'Update shipment details',
  ALLOCATIONS_ACTION_LINK_EXISTING_SHIPMENT: 'Link existing shipment',

  // ── Inventory (Monitor) ──
  INVENTORY_TITLE: 'Inventory',
  INVENTORY_EMPTY_TITLE: 'No materials found',
  INVENTORY_EMPTY_DESCRIPTION:
    'No incoming declarations have been added yet. Once you add the incoming declarations, inventory of materials will be visible here.',
  INVENTORY_NO_RESULTS_TITLE: 'No matching materials',

  // ── Inventory · Material details ──

  // ── Inventory · Material details · Summary table ──
  INVENTORY_SUMMARY_CONTRACTED: 'Total contracted quantity',
  INVENTORY_SUMMARY_SHIPPED: 'Total shipped quantity',
  INVENTORY_SUMMARY_OUTSTANDING: 'Total outstanding quantity',
  INVENTORY_SUMMARY_SHIPMENT: 'Total shipment quantity',
  INVENTORY_SUMMARY_RECEIVED_DECLARATION: 'Total received declaration quantity',
  INVENTORY_SUMMARY_ADJUSTED_CERTIFIED: 'Total adjusted certified quantity',
  INVENTORY_SUMMARY_PENDING: 'Total pending quantity',
  INVENTORY_SUMMARY_AVAILABLE: 'Total available quantity',
  INVENTORY_SUMMARY_ALLOCATED: 'Total allocated quantity',
  INVENTORY_SUMMARY_REMAINING_TO_ALLOCATE: 'Total remaining quantity to allocate',

  // ── Inventory ▸ detail tabs, summary reports and status vocabularies ──
  INVENTORY_MOVEMENT_EMPTY_TITLE: 'No material movement summary found',
  INVENTORY_MOVEMENT_EMPTY_DESCRIPTION:
    'No shipments have been added yet. Once you add a shipment, the material movement summary will be visible here.',
  INVENTORY_RECONCILIATION_EMPTY_TITLE: 'No physical reconciliation summary found',
  INVENTORY_RECONCILIATION_EMPTY_DESCRIPTION:
    'No shipments have been added yet. Once you add a shipment, the physical reconciliation summary of materials will be visible here.',
  INVENTORY_MASS_BALANCE_EMPTY_TITLE: 'No mass balance summary found',
  INVENTORY_MASS_BALANCE_EMPTY_DESCRIPTION:
    'No shipments have been added yet. Once you add a shipment, the mass balance summary of materials will be visible here.',
  INVENTORY_SUMMARY_NO_RESULTS_TITLE: 'Nothing in this range',
  INVENTORY_SUMMARY_NO_RESULTS_DESCRIPTION: 'Try a different date range or clear the filters.',
  INVENTORY_SUMMARY_TAB_MOVEMENT: 'Material movement summary',
  INVENTORY_SUMMARY_TAB_RECONCILIATION: 'Physical reconciliation summary',
  INVENTORY_SUMMARY_TAB_MASS_BALANCE: 'Mass balance summary',
  INVENTORY_VIEW_DETAILED: 'Detailed',
  INVENTORY_VIEW_SUMMARY: 'Summary',

  INVENTORY_TILE_OPENING_BALANCE: 'Total opening balance',
  INVENTORY_TILE_INBOUND_QUANTITY: 'Inbound quantity',
  INVENTORY_TILE_INBOUND_QUANTITY_INFO:
    'What was received in the selected range. Surplus and write-off are not counted here.',
  INVENTORY_TILE_ALLOCATED_QUANTITY: 'Total allocated quantity',
  INVENTORY_TILE_CLOSING_BALANCE: 'Total closing balance',

  INVENTORY_COL_GHG_SAVINGS: 'GHG savings',
  INVENTORY_COL_GHG_EMISSIONS: 'GHG emissions (g CO2 eq / MJ)',
  INVENTORY_COL_OPENING_BALANCE: 'Opening balance (In ${unit})',
  INVENTORY_COL_INBOUND_QUANTITY: 'Inbound quantity (In ${unit})',
  INVENTORY_COL_ALLOCATED_QUANTITY: 'Allocated quantity (In ${unit})',
  INVENTORY_COL_CLOSING_BALANCE: 'Closing balance (In ${unit})',
  INVENTORY_COL_RECONCILIATION_PERIOD: 'Reconciliation period',
  INVENTORY_COL_AVAILABLE_CLOSING_BALANCE: 'Available closing balance (In ${unit})',
  INVENTORY_COL_RECONCILED_QUANTITY: 'Reconciled quantity (In ${unit})',
  INVENTORY_COL_ADJUSTED_CLOSING_BALANCE: 'Adjusted closing balance (In ${unit})',
  INVENTORY_COL_PHYSICAL_BALANCE: 'Physical balance (In ${unit})',
  INVENTORY_COL_VARIANCE: 'Variance (In ${unit})',
  INVENTORY_COL_GRAND_TOTAL: 'Grand total',
  INVENTORY_COL_PERIOD: '${from} - ${to}',
  INVENTORY_GHG_EMISSIONS_VALUE: '${value} g CO2 e / MJ',
  INVENTORY_INBOUND_SUBTOTAL: 'Inbound balance contribution',
  INVENTORY_INBOUND_SUBTOTAL_INFO:
    'The inbound movements in this range added together, signed: what they add to the balance.',
  INVENTORY_OUTBOUND_SUBTOTAL: 'Outbound total',
  INVENTORY_OUTBOUND_SUBTOTAL_INFO:
    'The outbound movements in this range added together, signed: what they take from the balance.',
  INVENTORY_UNIT_PICKER: 'Unit the quantities are shown in',
  INVENTORY_FILTER_GHG_SAVINGS_RANGE: '${from} % to ${to} %',
  INVENTORY_FILTER_GHG_SAVINGS_BELOW: 'Below ${value} %',
  INVENTORY_COL_QUANTITY: 'Quantity (In ${unit})',
  INVENTORY_COL_SUPPLIER_CUSTOMER: 'Supplier / Customer',
  INVENTORY_COL_ASSOCIATED_DATE: 'Associated date',

  INVENTORY_ACTION_ADD_PHYSICAL_BALANCE: 'Add physical balance',
  INVENTORY_ACTION_UPDATE_PHYSICAL_BALANCE: 'Update physical balance',
  INVENTORY_ACTION_ADD_SURPLUS_WRITE_OFF: 'Add surplus / write off',
  INVENTORY_PHYSICAL_BALANCE_ADD_TITLE: 'Add physical balance',
  INVENTORY_PHYSICAL_BALANCE_UPDATE_TITLE: 'Update physical balance',
  INVENTORY_PHYSICAL_BALANCE_UNIT_INFO:
    'The balance is saved in the declaration unit; a working-unit entry is converted first.',
  INVENTORY_PHYSICAL_BALANCE_QUANTITY_INVALID: 'Enter a quantity of 0 or more.',
  INVENTORY_PHYSICAL_BALANCE_CONVERSION_FAILED:
    'This quantity could not be converted to the declaration unit. Enter it in the declaration unit instead.',
  INVENTORY_PHYSICAL_BALANCE_ADDED: 'Physical balance added successfully',
  INVENTORY_PHYSICAL_BALANCE_UPDATED: 'Physical balance updated successfully',
  INVENTORY_PHYSICAL_BALANCE_WHOLE_PERIOD:
    'Select one whole mass balance period to add a physical balance.',

  INVENTORY_TOTAL_ROW: 'Total',
  INVENTORY_NOT_APPLICABLE: 'Not applicable',
  INVENTORY_RANGE_TO_BEFORE_FROM: 'The To date must be on or after the From date.',

  INVENTORY_DETAIL_ERROR_TITLE: 'This material could not be opened',
  INVENTORY_DETAIL_ERROR_DESCRIPTION:
    'The link is incomplete. Open the material from the Inventory list.',
  INVENTORY_UNAVAILABLE_TITLE: 'Not available for this facility',
  INVENTORY_UNAVAILABLE_DESCRIPTION:
    'This breakdown is not available for a back-to-back account or storage yet.',
  INVENTORY_PERIOD_REQUIRED_TITLE: 'No mass balance period set up',
  INVENTORY_PERIOD_REQUIRED_DESCRIPTION:
    'Set up a mass balance period for this site in Account setup to see this summary.',

  RECONCILIATION_STATUS_GAIN: 'Gain',
  RECONCILIATION_STATUS_LOSS: 'Loss',
  RECONCILIATION_STATUS_RECONCILED: 'Reconciled',

  MOVEMENT_STATUS_FORWARD_INBOUND: 'Forward (Inbound)',
  MOVEMENT_STATUS_RECEIVED: 'Received',
  MOVEMENT_STATUS_TO_RECEIVE: 'To receive',
  MOVEMENT_STATUS_SURPLUS: 'Surplus',
  MOVEMENT_STATUS_WRITE_OFF: 'Write off',
  MOVEMENT_STATUS_FORWARD_OUTBOUND: 'Forward (Outbound)',
  MOVEMENT_STATUS_DISPATCHED: 'Dispatched',
  MOVEMENT_STATUS_ALLOCATED: 'Allocated',
  MOVEMENT_STATUS_DECLARATION_GENERATED: 'Declaration generated',

  // ── Allocations · detail page ──
  ALLOCATIONS_DETAIL_LOAD_ERROR: 'This allocation could not be loaded',
  ALLOCATIONS_REVOKE_SUCCESS: 'Allocation revoked successfully.',
  ALLOCATIONS_REJECT_SUCCESS: 'Declaration marked as rejected.',
  ALLOCATIONS_SHIPMENT_DETAILS_SAVED: 'Shipment details updated.',
  ALLOCATIONS_CONFIRM_EDIT_BODY:
    "Please note that a declaration can only be edited once. If you choose to edit and save now, you won't be able to make further changes.",
  ALLOCATIONS_CONFIRM_REJECT_TITLE: 'Mark declaration as rejected: ${transactionId}',
  ALLOCATIONS_CONFIRM_REJECT_BODY:
    'Are you sure you want to mark this declaration as rejected? This action cannot be undone',
  ALLOCATIONS_CONFIRM_REJECT_ACTION: 'Reject declaration',
  ALLOCATIONS_CONFIRM_REVOKE_TITLE: 'Revoke transaction: ${transactionId}',
  ALLOCATIONS_CONFIRM_REVOKE_BODY:
    "Are you sure you want to remove this transaction from '${sentFrom}' to '${customer}'? All associated credits will be revoked, and the balance will be returned to the source.",
  ALLOCATIONS_CONFIRM_REVOKE_ACTION: 'Revoke transaction',
  ALLOCATIONS_DECLARATION_SUCCESS: 'Declaration generated successfully.',
  ALLOCATIONS_FIELD_SENT_FROM: 'Sent from',
  ALLOCATIONS_ADD_ATTACHMENT_MODAL_TITLE: 'Add attachment: ${transactionId}',
  ALLOCATIONS_BANNER_CREDITS_RETIRED:
    'The credits for this allocation have been retired. No declaration can be generated from it.',
  ALLOCATIONS_BANNER_DECLARATION_REJECTED:
    'This declaration was rejected. No further action can be taken on this allocation.',
  ALLOCATIONS_BANNER_REVOKED:
    'This allocation was revoked and its certified quantity returned to the inbound declaration.',

  // ── Allocations · update shipment details ──
  ALLOCATIONS_UPDATE_SHIPMENT_TITLE: 'Update shipment details',
  ALLOCATIONS_SECTION_ALLOCATION_DETAILS: 'Allocation details',
  SECTION_SHIPPING_DETAILS_OPTIONAL: 'Shipping details (optional)',
  ALLOCATIONS_SHIPPING_DETAILS_DESCRIPTION:
    'You can add shipment details for this allocation. Adding shipment details will create outgoing shipment records. Generate declaration will only be available once the total shipment quantity matches the allocated certified quantity.',
  ALLOCATIONS_SHIPMENT_CARD_TITLE: 'Shipment - ${index}',
  ALLOCATIONS_ADD_MORE_SHIPMENTS: 'Add more shipments',
  ALLOCATIONS_SHIPMENT_QUANTITY_PLACEHOLDER: 'Enter shipment quantity',
  ALLOCATIONS_SHIPMENT_UNIT_PLACEHOLDER: 'Select unit',
  ALLOCATIONS_SHIPMENT_ID_REQUIRED: 'Shipment ID is required if adding shipment details.',
  ALLOCATIONS_SHIPMENT_QUANTITY_REQUIRED:
    'Shipment quantity is required if adding shipment details.',
  ALLOCATIONS_SHIPMENT_QUANTITY_POSITIVE: 'Shipment quantity should be greater than 0',
  ALLOCATIONS_SHIPMENT_QUANTITY_OVER_ALLOCATED:
    'Shipment quantity cannot be more than the allocated quantity.',
  ALLOCATIONS_SHIPMENT_UNIT_REQUIRED: 'Unit is required if adding shipment details.',
  ALLOCATIONS_SHIPMENT_DATE_REQUIRED: 'Date of dispatch is required if adding shipment details.',

  // ── Allocations · generate declaration ──
  ALLOCATIONS_FIELD_SAME_AS_SUPPLIER: 'Same as address of supplier',
  ALLOCATIONS_FIELD_SAME_AS_RECIPIENT: 'Same as address of recipient',
  ALLOCATIONS_POS_TITLE: 'Proof of Sustainability (PoS) for Biofuels and Bioliquids',
  ALLOCATIONS_POS_SUBTITLE: 'Applies under the Renewable Energy Directive (EU) 2018/2001 (RED III)',
  ALLOCATIONS_POS_VERSION: 'V4.0',
  ALLOCATIONS_POS_NUMBER: 'Unique Number of the PoS:',
  ALLOCATIONS_POS_ISSUANCE: 'Date of Issuance of the PoS:',
  ALLOCATIONS_POS_NAME: 'Name:',
  ALLOCATIONS_POS_ADDRESS: 'Address:',
  ALLOCATIONS_POS_CERTIFICATION_SYSTEM: 'Certification System:',
  ALLOCATIONS_POS_CERTIFICATE_NUMBER: 'Certificate Number:',
  ALLOCATIONS_POS_CONTRACT_NUMBER: 'Contract Number:',
  ALLOCATIONS_POS_DISPATCH_ADDRESS:
    'Address of dispatch / shipping point\nof the sustainable material:',
  ALLOCATIONS_POS_RECEIPT_ADDRESS:
    'Address of receipt / receiving point\nof the sustainable material:',
  ALLOCATIONS_POS_DISPATCH_DATE: 'Date of dispatch of the sustainable\nmaterial:',
  ALLOCATIONS_POS_TYPE_OF_PRODUCT: 'Type of Product:',
  ALLOCATIONS_POS_TYPE_OF_RAW_MATERIAL: 'Type of Raw Material :',
  ALLOCATIONS_POS_ADDITIONAL_INFORMATION: 'Additional Information (voluntary):',
  ALLOCATIONS_POS_COUNTRY_OF_ORIGIN: 'Country of Origin (of the raw\nmaterial):',
  ALLOCATIONS_POS_QUANTITY: 'Quantity:',
  ALLOCATIONS_POS_UNIT_CUBIC_METERS_15C: 'm^3^ / 15°C',
  ALLOCATIONS_POS_UNIT_CUBIC_METERS: 'm^3^',
  ALLOCATIONS_POS_UNIT_METRIC_TONS: 'metric tons',
  ALLOCATIONS_POS_ENERGY_CONTENT: 'Energy Content (MJ):',
  ALLOCATIONS_POS_UNIT_MJ: 'MJ',
  ALLOCATIONS_POS_EU_RED_COMPLIANT: 'EU RED Compliant material^1^ :',
  ALLOCATIONS_POS_ISCC_COMPLIANT: 'ISCC Compliant material (volunt.)^2^ :',
  ALLOCATIONS_POS_CHAIN_OF_CUSTODY: 'Chain of custody option (voluntary) :',
  ALLOCATIONS_POS_COUNTRY_OF_BIOFUEL: 'Country of biofuel production:',
  ALLOCATIONS_POS_START_DATE_BIOFUEL: 'Start date of biofuel production^3^ :',
  ALLOCATIONS_POS_START_DATE_BIOLIQUID:
    'If applicable, start date of bioliquid / biomass fuel use^3,4^',
  ALLOCATIONS_POS_SUSTAINABILITY_CRITERIA:
    'The raw material complies with the relevant sustainability criteria according to Art. 29 (2) - (7) RED III^5^',
  ALLOCATIONS_POS_INTERMEDIATE_CROP:
    'The agricultural biomass was cultivated as intermediate crop (if applicable)',
  ALLOCATIONS_POS_LOW_ILUC_RISK:
    'The agricultural biomass additionally fulfills the measures for low ILUC risk feedstocks (if applicable)',
  ALLOCATIONS_POS_WASTE_OR_RESIDUE:
    'The raw material meets the definition of waste or residue according to the RED III^6^',
  ALLOCATIONS_POS_SUPPORT_RECEIVED:
    'Was support for the production of the fuel or fuel precursor received?^7^',
  ALLOCATIONS_POS_SECTION_GHG: 'Greenhouse Gas (GHG) emission information',
  ALLOCATIONS_POS_RED_III_TOTAL_VALUE: 'Total value according to RED III applied',
  ALLOCATIONS_POS_E_EQUALS: 'E =',
  ALLOCATIONS_POS_TOTAL_GHG_EMISSIONS:
    'Total GHG emissions from supply and use of the fuel (gCO2eq/MJ)',
  ALLOCATIONS_POS_UNIT_GCO2EQ_MJ: 'gCO2eq/MJ',
  ALLOCATIONS_POS_TERM_EEC: 'Eec',
  ALLOCATIONS_POS_TERM_EL: 'El',
  ALLOCATIONS_POS_TERM_EP: 'Ep',
  ALLOCATIONS_POS_TERM_ETD: 'Etd',
  ALLOCATIONS_POS_TERM_EU: 'Eu',
  ALLOCATIONS_POS_TERM_ESCA: 'Esca',
  ALLOCATIONS_POS_TERM_ECCS: 'Eccs',
  ALLOCATIONS_POS_TERM_ECCR: 'Eccr',
  ALLOCATIONS_POS_TERM_E: 'E',
  ALLOCATIONS_POS_UNIT_GCO2_EQ_MJ: 'gCO2 eq / MJ',
  ALLOCATIONS_POS_ALLOCATED_HEAT: 'Allocated to heat:',
  ALLOCATIONS_POS_UNIT_HEAT: 'gCO2 eq / MJ heat',
  ALLOCATIONS_POS_ALLOCATED_ELECTRICITY: 'Allocated to electricity:',
  ALLOCATIONS_POS_UNIT_ELECTRICITY: 'gCO2 eq / MJ electricity',
  ALLOCATIONS_POS_ESCA_BONUS_CAP:
    'Esca: Specify which Bonus or Cap applies to any claimed Esca savings:',
  ALLOCATIONS_POS_NUTS2_AREA: 'If applicable, please specify the NUTS2 area:',
  ALLOCATIONS_POS_SAVING_TITLE: 'GHG emission saving^9^:',
  ALLOCATIONS_POS_SAVING_USEFUL_HEAT:
    'Bioliquids / Biomass fuels for the production of\nuseful heat, as well as for the production\nof energy for heating and / or cooling (%)',
  ALLOCATIONS_POS_SAVING_SUBSTITUTION:
    'Biomass fuels for the production of useful heat, in\nwhich a direct physical substitution of\ncoal can be demonstrated (%)',
  ALLOCATIONS_POS_VALIDITY:
    'This form is valid without signature. By issuing this PoS, the issuing party guarantees that all information made on this\nProof of Sustainability are correct, in compliance with the requirements of ISCC and the RED II, and that the biofuel or\nbioliquid has not already been used to fulfill a national quota obligation.',
  ALLOCATIONS_POS_ADDON_FOOD_SECURITY: 'Food Security Standard (FSS) - 202 - 04',
  ALLOCATIONS_POS_ADDON_DEFORESTATION: 'EU Deforestation Regulation (EUDR) - 202 - 09',
  ALLOCATIONS_POS_ADDON_NON_GMO_FOOD_FEED: 'Non - GMO for Food and Feed - 205 - 03',
  ALLOCATIONS_POS_ADDON_NON_GMO_TECHNICAL: 'Non - GMO for Technical Markets - 205 - 04',
  ALLOCATIONS_POS_NOT_VALID_WITHOUT_ID: 'Not valid without ID number of the ISCC certificate above',
  ALLOCATIONS_POS_SECTION_EXPLANATIONS: 'Explanations',
  ALLOCATIONS_POS_LEGEND_EEC: 'GHG emissions from the extraction or cultivation of raw materials',
  ALLOCATIONS_POS_LEGEND_EL:
    'Annualized (over 20 years) GHG emissions from carbon stock change due to land use change',
  ALLOCATIONS_POS_LEGEND_EP: 'GHG emissions from processing',
  ALLOCATIONS_POS_LEGEND_ETD:
    'GHG emissions from transport and distribution. etd includes downstream emissions for distribution up to\nand including the filling station',
  ALLOCATIONS_POS_LEGEND_EU: 'GHG emissions from the fuel in use',
  ALLOCATIONS_POS_LEGEND_ESCA:
    'GHG emissions savings from soil carbon accumulation via improved agricultural management',
  ALLOCATIONS_POS_LEGEND_ECCS: 'GHG emissions savings from carbon capture and geological storage',
  ALLOCATIONS_POS_LEGEND_ECCR: 'GHG emissions savings from carbon capture and replacement',
  ALLOCATIONS_POS_LEGEND_E: 'Total GHG emissions from supply and use of the fuel',
  ALLOCATIONS_POS_EXPLANATION_1:
    '1) The claim “EU RED Compliant” means that the entire upstream supply chain, including cultivation or collection of the\nraw material, is certified under a voluntary scheme that is recognised in the framework of the RED. Sustainable material\nhas to be considered “EU RED Compliant” if the ISCC certified operator receives deliveries from suppliers that are\ncertified under any recognised voluntary certification scheme.  Please see ISCC EU System Document 203 for further\ninformation.',
  ALLOCATIONS_POS_EXPLANATION_2:
    '2) The claim “ISCC Compliant” means that the entire upstream supply chain, including the cultivation or collection of the\nraw material is certified according to ISCC, and the material used in the supply chain consists entirely and solely of\nISCC material, at least on a quantity bookkeeping basis. The statement “ISCC Compliant” can only be made if the ISCC\ncertified operator has received an equivalent amount of incoming material with the statement “ISCC Compliant” on the\nSustainability Declaration. Please see ISCC EU System Document 203 for further information.',
  ALLOCATIONS_POS_EXPLANATION_3:
    '3) An installation shall be considered to be in operation once the physical production of fuel, heat or cooling, or\nelectricity has started (i.e. once the production of fuels including biofuels, biogas or bioliquids, or production of heat,\ncooling or electricity from biomass fuels has started).  (see Article 29 (10) Renewable Energy Directive (EU) 2018/2001)',
  ALLOCATIONS_POS_EXPLANATION_4:
    '4) Users of bioliquids / biomass fuels are installations that generate electricity, heating or cooling from gaseous or solid\nfuels (i.e. biomass fuels), or from liquid fuels (i.e. bioliquids)',
  ALLOCATIONS_POS_EXPLANATION_5:
    '5) Applicable to agricultural and forest biomass including residues from agricultural, aquaculture, fisheries and\nforestry',
  ALLOCATIONS_POS_EXPLANATION_6:
    '6) Applicable to waste and residues and products produced from waste and residues',
  ALLOCATIONS_POS_EXPLANATION_7:
    '7) According to Art. 2(5) of the RED III support schemes can include investment aid, tax exemptions or reductions, tax\nrefunds, renewable energy obligation support schemes including those using green certificates, and direct price support\nschemes including feed-in tariffs and sliding or fixed premium payments',
  ALLOCATIONS_POS_EXPLANATION_8:
    '8) Emissions of non-CO2 greenhouse gases (N2O and CH4) of the fuel in use must be included in the Eu factor for\nbioliquids and biomass fuels',
  ALLOCATIONS_POS_EXPLANATION_9:
    '9) Saving is calculated automatically based on the fossil fuel comparator according to RED III:',
  ALLOCATIONS_POS_SAVING_FORMULA: '(EF – EB)/EF',
  ALLOCATIONS_POS_SAVING_FORMULA_EB:
    'where EB = total emissions from the biofuel, bioliquid or biomass fuel',
  ALLOCATIONS_POS_SAVING_FORMULA_EF: 'and EF = total emissions from the fossil fuel comparator.',
  ALLOCATIONS_POS_COMPARATORS: 'Fossil fuel comparators:',
  ALLOCATIONS_POS_COMPARATOR_TRANSPORT: 'Biofuels for transport: 94 gCO2eq/MJ;',
  ALLOCATIONS_POS_COMPARATOR_ELECTRICITY:
    'Bioliquids/Biomass fuels used for electricity: 183 gCO2eq/MJ;',
  ALLOCATIONS_POS_COMPARATOR_OUTERMOST:
    'Biomass fuels used for the production of electricity (outermost regions): 212 gCO2eq/MJ;',
  ALLOCATIONS_POS_COMPARATOR_USEFUL_HEAT:
    'Bioliquids/Biomass fuels used for the production of useful heat, as well as for the production of energy for heating and/or\ncooling: 80 gCO2eq/MJ;',
  ALLOCATIONS_POS_COMPARATOR_SUBSTITUTION:
    'Biomass fuels used for the production of useful heat, in which a direct physical substitution of coal can be\ndemonstrated: 124 gCO2eq/MJ;',
  ALLOCATIONS_DECLARATION_PREVIEW_TITLE: 'Declaration preview: ${transactionIds}',
  ALLOCATIONS_ACTION_CONFIRM_DECLARATION: 'Confirm declaration & Download',
  // ── Allocations · link existing shipment ──
  ALLOCATIONS_LINK_TITLE: 'Link outgoing shipment: ${transactionId}',
  ALLOCATIONS_LINK_DESCRIPTION:
    'Link multiple outgoing shipments with the allocation, only details that match will be selected',
  ALLOCATIONS_LINK_STEP_SELECT: 'Select outgoing shipment',
  ALLOCATIONS_LINK_EMPTY: 'No outgoing shipment can be linked',
  ALLOCATIONS_LINK_NONE_BODY:
    'No outgoing shipment matches this allocation’s material, site, customer and terminal.',
  ALLOCATIONS_COL_TOTAL_ORDERS_LINKED: 'Total order linked',
  // ── Allocations · edit declaration ──
  ALLOCATIONS_EDIT_DECLARATION_TITLE: 'Edit declarations',
  ALLOCATIONS_DECLARATION_STEP_DETAILS: 'Declaration details',
  ALLOCATIONS_DECLARATION_STEP_MATERIALS: 'Materials details',
  ALLOCATIONS_DECLARATION_STEP_EMISSIONS: 'Emission details',
  ALLOCATIONS_FIELD_SD_NUMBER: 'Unique number of Sustainability declaration',
  ALLOCATIONS_FIELD_DATE_OF_ISSUANCE: 'Date of issuance',
  ALLOCATIONS_FIELD_CERTIFICATE_NUMBER: 'Certificate number',
  ALLOCATIONS_FIELD_CONTRACT_NUMBER: 'Contract number',
  ALLOCATIONS_FIELD_ADDRESS_OF_DISPATCH: 'Address of dispatch / shipping point',
  ALLOCATIONS_FIELD_ADDRESS_OF_RECEIPT: 'Address of receipt / receiving point',
  ALLOCATIONS_SAME_AS_SUPPLIER_ADDRESS: 'Same as address of supplier',
  ALLOCATIONS_SAME_AS_RECIPIENT_ADDRESS: 'Same as address of recipient',

  ALLOCATIONS_FIELD_ADDITIONAL_INFORMATION: 'Additional information',
  ALLOCATIONS_FIELD_TOTAL_CERTIFIED_QUANTITY: 'Total certified quantity',
  ALLOCATIONS_FIELD_ENERGY_CONTENT: 'Energy content (MJ)',
  ALLOCATIONS_FIELD_ISCC_COMPLIANT: 'ISCC Compliant material',
  ALLOCATIONS_FIELD_EU_RED_COMPLIANT: 'EU RED Compliant material',
  ALLOCATIONS_FIELD_CHAIN_OF_CUSTODY: 'Chain of custody option',
  ALLOCATIONS_FIELD_COUNTRY_OF_BIOFUEL: 'Country of biofuel production',
  ALLOCATIONS_FIELD_START_DATE_BIOFUEL: 'Start date of biofuel production',
  ALLOCATIONS_FIELD_START_DATE_BIOLIQUID:
    'If applicable, start date of bioliquid / biomass fuel use',
  ALLOCATIONS_FIELD_SUSTAINABILITY_CRITERIA:
    'Raw material complies with sustainability criteria (Art. 29(2) - (7) RED III)',
  ALLOCATIONS_FIELD_INTERMEDIATE_CROP:
    'Agricultural biomass cultivated as intermediate crop (if applicable)',
  ALLOCATIONS_FIELD_LOW_ILUC_RISK:
    'Agricultural biomass additionally fulfills the measures for low ILUC risk feedstock (if applicable)',
  ALLOCATIONS_FIELD_WASTE_OR_RESIDUE:
    'Raw material meets the definition of waste or residue according to the RED III',
  ALLOCATIONS_FIELD_WASTE_PERMIT_NUMBER:
    'If applicable, please specify waste or animal by-product permit number',
  ALLOCATIONS_FIELD_SUPPORT_RECEIVED:
    'Was support for the production of the fuel or its precursor received?',
  ALLOCATIONS_FIELD_SUPPORT_NATURE: 'If yes, please specify support nature and scheme',

  ALLOCATIONS_FIELD_DEFAULT_VALUE_APPLIED: 'Default value according to RED III applied',
  ALLOCATIONS_FIELD_TOTAL_GHG_EMISSIONS: 'Total GHG emissions (gCO2 e / MJ)',
  ALLOCATIONS_FIELD_EEC:
    'Eec: Emissions from the extraction or cultivation of raw materials (gCO2 e / MJ)',
  ALLOCATIONS_FIELD_EL: 'El: Emissions from land-use change (gCO2 e / MJ)',
  ALLOCATIONS_FIELD_EP: 'Ep: Emissions from processing (gCO2 e / MJ)',
  ALLOCATIONS_FIELD_ETD: 'Etd: Emissions from transport and distribution (gCO2 e / MJ)',
  ALLOCATIONS_FIELD_EU: 'Eu: Emissions from the fuel in use (gCO2 e / MJ)',
  ALLOCATIONS_FIELD_ESCA: 'Esca: Emission savings from soil carbon accumulation (gCO2 e / MJ)',
  ALLOCATIONS_FIELD_ECCS: 'Eccs: Emission savings from carbon capture and storage (gCO2 e / MJ)',
  ALLOCATIONS_FIELD_ECCR:
    'Eccr: Emission savings from carbon capture and replacement (gCO2 e / MJ)',
  ALLOCATIONS_FIELD_ALLOCATED_HEAT: 'Allocated heat (gCO2 e / MJ)',
  ALLOCATIONS_FIELD_ALLOCATED_ELECTRICITY: 'Allocated electricity (gCO2 e / MJ)',
  ALLOCATIONS_FIELD_ESCA_BONUS_CAP: 'Esca: Specify which Bonus or claimed Esca saving',
  ALLOCATIONS_FIELD_NUTS2_AREA: 'If applicable, please specify the NUTS2 area',
  ALLOCATIONS_FIELD_SAVING_TRANSPORT: 'Biofuels for transport (%)',
  ALLOCATIONS_FIELD_SAVING_ELECTRICITY:
    'Bioliquids / Biomass fuels for the production of electricity (%)',
  ALLOCATIONS_FIELD_SAVING_OUTERMOST:
    'Biomass fuels for the production of electricity in the outermost regions (%)',
  ALLOCATIONS_FIELD_SAVING_USEFUL_HEAT:
    'Bioliquids / Biomass fuels for the production of useful heat (%)',
  ALLOCATIONS_FIELD_SAVING_SUBSTITUTION:
    'Biomass fuels for the production of useful heat, involving direct physical substitution of coal (%)',

  ALLOCATIONS_FILTER_DAYS_LEFT_1: '1 day left',
  ALLOCATIONS_FILTER_DAYS_LEFT_3: '3 days left',
  ALLOCATIONS_FILTER_DAYS_LEFT_5: '5 days left',
  ALLOCATIONS_FILTER_DAYS_LEFT_WEEK: '1 week left',
  ALLOCATIONS_SUSTAINABILITY_MISMATCH:
    "Sustainability mismatch: Outgoing shipment's ${attribute} (${shipmentValue}) does not match the order value (${orderValue}).",
  TABLE_EDIT_COLUMN: 'Edit column',
  TABLE_DEFAULT_VIEW: 'Default view',
  TABLE_SAVE_VIEW: 'Save view',

  ALLOCATIONS_BULK_FIELDS_MISMATCH:
    'The required fields do not match. You cannot generate declarations for the selected fulfillments unless all required fields match, except for Quantity and Energy Content.',

  // ── `transaction_status` (raw enum) ──
  STATUS_TRANSACTION_AWAITING_APPROVAL: 'Awaiting approval',
  STATUS_TRANSACTION_REJECTED: 'Rejected',
  STATUS_TRANSACTION_TRANSFERRED: 'Transferred',
  STATUS_TRANSACTION_DISPATCHED: 'Dispatched',

  // ── Incoming shipments ──
  INCOMING_SHIPMENTS_TITLE: 'Incoming Shipments',
  INCOMING_SHIPMENTS_LOAD_ERROR: "Couldn't load this shipment. Please try again.",
  INCOMING_SHIPMENTS_IMPORT: 'Import incoming shipments',
  INCOMING_SHIPMENTS_ADD: 'Add incoming shipment',
  INCOMING_SHIPMENTS_EMPTY_TITLE: 'No incoming shipments found',
  INCOMING_SHIPMENTS_EMPTY_DESCRIPTION:
    'No shipment has been added yet. Click on button below to add new incoming shipment',
  INCOMING_SHIPMENTS_NO_RESULTS_TITLE: 'No matching incoming shipments',
  INCOMING_SHIPMENTS_LINK_CONTRACTS: 'Link contracts',
  INCOMING_SHIPMENTS_DELETE_TITLE: 'Delete shipment',
  INCOMING_SHIPMENTS_DELETE_BODY_TITLE: 'Delete shipment: ${shipmentId}',
  INCOMING_SHIPMENTS_DELETE_DESCRIPTION:
    'Are you sure you want to delete the shipment of ‘${materialName}’ from ‘${supplierName}’?',
  INCOMING_SHIPMENTS_DAYS_LEFT: '${days} days',
  // Column headers
  INCOMING_SHIPMENTS_COL_TOTAL_DECLARATIONS_RECEIVED: 'Total declarations received',

  // ─── Add/Edit shipment form ───
  INCOMING_SHIPMENTS_ADD_TITLE: 'Add shipment',
  INCOMING_SHIPMENTS_EDIT_TITLE: 'Edit shipment',
  INCOMING_SHIPMENTS_INVALID_ID_PREFIX: 'Use up to 4 letters or numbers.',
  INCOMING_SHIPMENTS_TRACKING_UNIT_REQUIRED: 'Tracking unit is mandatory if density has been added',
  INCOMING_SHIPMENTS_TRACKING_DENSITY_REQUIRED:
    'Density is mandatory if Tracking unit has been selected',
  INCOMING_SHIPMENTS_SAVED_FLASH: 'Shipment saved successfully.',
  INCOMING_SHIPMENTS_DELETED: 'Shipment deleted successfully.',
  INCOMING_SHIPMENTS_ADDED_TITLE: 'Shipment added successfully',
  INCOMING_SHIPMENTS_ADDED_BODY:
    'Shipment ${shipmentId} has been saved. Would you like to upload sustainability declarations for this shipment now? You can also do this later from the shipments table.',
  INCOMING_SHIPMENTS_DISCHARGE_BEFORE_DISPATCH:
    'Date of discharge cannot be before the date of dispatch.',

  SHIPMENT_FORM_SHIPMENT_ID_PREFIX: 'Shipment ID prefix',
  SHIPMENT_FORM_SHIPMENT_ID_NUMBER: 'Shipment ID number',
  SHIPMENT_FORM_MODAL_HEADING: 'Create new outgoing shipment',
  SHIPMENT_FORM_NO_MATERIAL_ASSIGNED: 'No material assigned',
  SHIPMENT_FORM_DATE_OF_DISCHARGE: 'Date of discharge (Optional)',

  SHIPMENT_FORM_TRACKING_UNIT: 'Tracking unit (Optional)',
  SHIPMENT_FORM_TRACKING_UNIT_NONE: 'None',
  SHIPMENT_FORM_DECLARATION_UNIT: 'declaration unit',
  SHIPMENT_FORM_SHIPMENT_QUANTITY_DECLARATION: 'Shipment quantity (${unit}) (Declaration unit)',
  SHIPMENT_FORM_SHIPMENT_QUANTITY_WORKING: 'Shipment quantity (${unit}) (Working unit)',
  SHIPMENT_FORM_SHIPMENT_QUANTITY_TRACKING: 'Shipment quantity (${unit}) (Tracking unit)',
  SHIPMENT_FORM_CONVERSION_FACTOR: 'Conversion factor (${toUnit} per ${fromUnit})',
  SHIPMENT_FORM_DENSITY: 'Density (${weightUnit} per ${volumeUnit}) (Optional)',
  SHIPMENT_FORM_DENSITY_REQUIRED_FOR_ENTRY:
    'Density / conversion factor is required to convert shipment quantity to declaration unit',
  SHIPMENT_FORM_DENSITY_PLACEHOLDER: 'Enter the density',
  SHIPMENT_FORM_TRACKING_DENSITY:
    'Density for tracking unit (${weightUnit} per ${volumeUnit}) (Optional)',
  SHIPMENT_FORM_TRACKING_CONVERSION_FACTOR:
    'Conversion factor for tracking unit (${toUnit} per ${fromUnit})',
  SHIPMENT_FORM_CONVERSION_FAILED: "Couldn't convert this quantity. Check the density.",
  SHIPMENT_FORM_SHIPMENT_QUANTITY_PLACEHOLDER: 'Enter the shipment quantity',

  SHIPMENT_ATTACHMENT_ERROR_NOT_PDF: '${name}: invalid file format. Only PDF is supported.',
  SHIPMENT_ATTACHMENT_ERROR_TOO_LARGE: '${name}: the file size exceeds 5 MB.',
  SHIPMENT_ATTACHMENT_ERROR_DUPLICATE: '${name} has already been added.',
  SHIPMENT_ATTACHMENT_ERROR_TOO_MANY: '${name} was not added — 5 files is the maximum.',
  // ── Incoming shipments · Shipment details ──
  INCOMING_SHIPMENTS_DETAIL_TAB_LINKED_CONTRACTS: 'Linked contracts',
  INCOMING_SHIPMENTS_DETAIL_TAB_LINKED_DECLARATIONS: 'Linked declarations',
  INCOMING_SHIPMENTS_DETAIL_CARD_TITLE: 'Shipment details',
  INCOMING_SHIPMENTS_DETAIL_LINKED_CONTRACTS_EMPTY_TITLE: 'No contracts linked',
  INCOMING_SHIPMENTS_DETAIL_LINKED_CONTRACTS_EMPTY_DESCRIPTION:
    'No contracts have been linked yet. Click the button below to link contracts.',
  INCOMING_SHIPMENTS_DETAIL_LINKED_DECLARATIONS_EMPTY_TITLE: 'No declarations added yet',
  INCOMING_SHIPMENTS_DETAIL_LINKED_DECLARATIONS_EMPTY_DESCRIPTION:
    'No declarations have been added yet. Click the button below to add declarations.',

  // ── Incoming shipments · Shipment details · Linked contracts table ──
  INCOMING_SHIPMENTS_LINKED_CONTRACTS_SUMMARY_ASSIGNED: 'Assigned quantity (In ${unit} unit)',
  INCOMING_SHIPMENTS_LINKED_CONTRACTS_SUMMARY_UNASSIGNED: 'Unassigned quantity (In ${unit} unit)',
  INCOMING_SHIPMENTS_LINKED_CONTRACTS_COL_LINKED_SHIPMENTS: 'Linked shipments',
  INCOMING_SHIPMENTS_LINKED_CONTRACTS_ACTION_REMOVE_LINK: 'Remove link',
  INCOMING_SHIPMENTS_LINKED_CONTRACTS_REMOVED: 'Contract linkage removed.',
  INCOMING_SHIPMENTS_LINKED_CONTRACTS_REMOVE_LINK_BODY_TITLE:
    'Remove link of contract ${contractId} from ${shipmentId}',
  INCOMING_SHIPMENTS_LINKED_CONTRACTS_REMOVE_LINK_DESCRIPTION:
    'Are you sure you want to remove this link?',

  // ── Incoming shipments · Shipment details · Linked declarations tab ──
  INCOMING_SHIPMENTS_LINKED_DECLARATIONS_REMOVE_LINKAGE_BODY_TITLE:
    'Remove linkage of declaration ${referenceId} from ${shipmentId}',

  // ── Incoming shipments · Shipment details · Attachments tab ──
  INCOMING_SHIPMENTS_ADD_ATTACHMENT_MODAL_TITLE: 'Add attachment: ${shipmentId}',

  // ── Incoming shipments · Shipment details · Discrepancy modal ──

  ACCOUNT_SETUP_TITLE: 'Account setup',
  ACCOUNT_SETUP_TAB_COMPANY_PROFILE: 'Company profile',
  ACCOUNT_SETUP_TAB_COMPANY_STRUCTURE: 'Company structure',
  ACCOUNT_SETUP_TAB_MASS_BALANCE_PERIOD: 'Mass balance period',
  ACCOUNT_SETUP_TAB_MATERIALS: 'Materials',
  ACCOUNT_SETUP_TAB_SYSTEM_SETTINGS: 'System settings',
  ACCOUNT_SETUP_COMPANY_PROFILE_SAVED_FLASH: 'Company profile saved successfully.',

  ACCOUNT_SETUP_STRUCTURE_TAB_SITES: 'Sites',
  ACCOUNT_SETUP_STRUCTURE_TAB_BACK_TO_BACK: 'Back to back accounts',

  BACK_TO_BACK_ADD: 'Add back to back accounts',
  BACK_TO_BACK_EDIT_TITLE: 'Edit back to back accounts',
  BACK_TO_BACK_EMPTY_TITLE: 'No back to back accounts found',
  BACK_TO_BACK_EMPTY_DESCRIPTION:
    'For trades where material ships directly from supplier to customer, bypassing your sites.',
  BACK_TO_BACK_NO_RESULTS_TITLE: 'No matching back to back accounts',
  BACK_TO_BACK_DECLARATION_HINT:
    'This will be used as the supplier details when generating the declaration. For the “Shipping From” field, the information will be fetched from the shipping details in the inbound declaration.',
  BACK_TO_BACK_SAVED: 'Back to back account saved.',
  ACCOUNT_SETUP_STRUCTURE_TAB_STORAGE_UNITS: 'Storage units',

  SITES_ADD: 'Add site',
  SITES_IMPORT: 'Import sites',
  SITES_IMPORT_TERMINALS: 'Import terminals',
  SITES_EMPTY_TITLE: 'No sites found',
  SITES_EMPTY_DESCRIPTION: 'No site has been added yet. Click on button below to add new site.',
  SITES_NO_RESULTS_TITLE: 'No matching sites',
  SITES_ACTION_ASSIGN_MATERIALS: 'Assign materials',

  SITES_ADD_TITLE: 'Add site',
  SITES_EDIT_TITLE: 'Edit site',
  SITES_SAVED: 'Site saved successfully.',
  SITES_LOAD_ERROR: "Couldn't load this site. Please try again.",
  SITES_TERMINAL_HEADING: 'Terminal-${index}',
  SITES_ADD_TERMINAL: 'Add terminal',
  SITES_CERTIFICATE_LOOKUP_CHECKING: 'Checking the ISCC certificate directory…',
  SITES_CERTIFICATE_LOOKUP_NOT_FOUND: 'No valid ISCC certificate found for this number.',

  SITES_DETAIL_TAB_MATERIAL_SETTINGS: 'Material settings',
  SITES_DETAIL_TAB_MASS_BALANCE_PERIOD: 'Mass balance period',
  SITES_ADD_TERMINALS: 'Add terminals',
  SITES_TERMINALS_EMPTY_TITLE: 'No terminals found',
  SITES_TERMINALS_EMPTY_DESCRIPTION:
    'No terminals found. Add terminals to start managing them here.',
  SITES_TERMINALS_NO_RESULTS_TITLE: 'No matching terminals',
  SITES_TERMINAL_COL_MATERIALS_ASSIGNED: 'No. of materials assigned',
  SITES_TERMINAL_NO_MATERIALS: 'No materials assigned',
  SITES_TERMINAL_ADD_TITLE: 'Add terminal: ${siteName}',
  SITES_TERMINAL_EDIT_TITLE: 'Edit terminal: ${siteName}',
  SITES_ADD_MORE_TERMINALS: 'Add more terminals',
  SITES_TERMINAL_SAVED: 'Terminal saved successfully.',
  SITES_TERMINAL_DELETE_LOCKED:
    'Delete is permitted only for terminals for which no shipments have been linked',
  SITES_TERMINAL_DELETE_TITLE: 'Delete terminal',
  SITES_TERMINAL_DELETE_BODY_TITLE: 'Delete ${terminalName}?',
  SITES_TERMINAL_DELETE_DESCRIPTION: 'This terminal is removed from the site permanently.',
  SITES_TERMINAL_DELETED: 'Terminal deleted successfully.',

  SITES_COL_SERIAL_NO: 'S.No.',
  SITES_COL_ASSOCIATED_CERTIFICATE: 'Associated certificate',
  SITES_COL_SITE_TYPES: 'Site types',
  SITES_COL_ASSOCIATED_TERMINALS: 'Associated terminals',
  SITES_COL_ASSOCIATED_MATERIALS: 'Associated materials',
  SITES_COL_ASSOCIATED_PROCESSES: 'Associated processes',
  SITES_COL_ACTIONS: 'Actions',

  MATERIALS_EMPTY_TITLE: 'Assign materials to this site',
  MATERIALS_EMPTY_DESCRIPTION: 'Assign materials to this site to begin adding inbounds',
  MATERIALS_NO_RESULTS_TITLE: 'No matching materials',
  MATERIALS_ADD: 'Add material',
  MATERIALS_EDIT_TITLE: 'Edit material',
  MATERIALS_SAVED: 'Material saved.',
  MATERIALS_TAB_EMPTY_TITLE: 'No materials found',
  MATERIALS_TAB_EMPTY_DESCRIPTION:
    'Add the materials you trade to start recording inbounds and outbounds.',
  MATERIALS_CONVENTIONAL_INFO:
    'Since the Material Type is set to Conventional, the system treats this material as infinite and automatically performs all necessary conversions and calculations.',
  MATERIALS_CONVERSION_FACTOR_FIXED: 'Conversion factor (${workingUnit} per ${declarationUnit})',
  MATERIALS_CONVERSION_FACTOR_DISCRETE: 'Conversion factor (${declarationUnit} per ${workingUnit})',
  MATERIALS_DENSITY: 'Density (${weightUnit} per ${volumeUnit}) (Optional)',
  MATERIALS_EXAMPLE_TITLE: 'Example',
  MATERIALS_EXAMPLE_SHIPMENT: 'Shipment',
  MATERIALS_EXAMPLE_IN_UNIT: 'In ${unit}',
  MATERIALS_EXAMPLE_MULTIPLY: '${quantity} x ${factor} = ${result} ${unit}',
  MATERIALS_EXAMPLE_DIVIDE: '${quantity} / ${factor} = ${result} ${unit}',
  MATERIALS_ENERGY_CONTENT: 'Energy content (${unit})',
  MATERIALS_ENERGY_MULTIPLIER: 'Multiplier',
  MATERIALS_ALLOCATING_QUANTITY: 'Allocating quantity',
  MATERIALS_NOT_APPLICABLE: 'Not applicable',
  MATERIALS_REMOVE_FROM_TERMINAL: 'Remove from terminal',
  MATERIALS_REMOVE_LOCKED:
    'Remove action not allowed because this material is currently available in the inventory',
  MATERIALS_REMOVE_TITLE: 'Remove material',
  MATERIALS_REMOVE_BODY_TITLE: 'Remove ${materialName} from this terminal?',
  MATERIALS_REMOVE_DESCRIPTION: 'The material stays on the site; only this terminal loses it.',
  MATERIALS_REMOVED_FROM_TERMINAL: 'Material removed from the terminal.',
  MATERIALS_ASSIGNED_TO_TERMINAL: 'Materials assigned to the terminal.',
  MATERIALS_LIST_EMPTY: 'No materials for this certification type',

  SUPPLIERS_TITLE: 'Manage supplier',
  SUPPLIERS_ADD: 'Add supplier',
  SUPPLIERS_EDIT_TITLE: 'Edit supplier',
  SUPPLIERS_IMPORT: 'Import suppliers',
  SUPPLIERS_IMPORT_SITES: 'Import suppliers sites',
  SUPPLIERS_SAVED: 'Supplier saved.',
  SUPPLIERS_EMPTY_TITLE: 'No suppliers found',
  SUPPLIERS_EMPTY_DESCRIPTION:
    'No suppliers have been added yet. You will need to add supplier to manage Outbounds',
  SUPPLIERS_NO_RESULTS_TITLE: 'No matching suppliers',
  SUPPLIERS_SECTION_DETAILS: 'Supplier details',
  SUPPLIERS_SHIPPING_SECTION_DESCRIPTION:
    'You can add details for multiple sites under a single supplier. For each site, you will be able to send a data request to the designated site manager, who will be responsible for providing the required data',
  SHIPPING_SITE_CARD_HEADING: 'Shipping site - ${index}',
  SHIPPING_SITE_ADD_MORE: 'Add more shipping sites',

  SITES_MB_PERIOD_EMPTY_TITLE: 'No mass balance period found',
  SITES_MB_PERIOD_EMPTY_DESCRIPTION:
    'No mass balance period found. Update mass balance period to add declarations',
  SITES_MB_PERIOD_EMPTY_DESCRIPTION_SCOPED:
    'Update the mass balance period for ${scope} so you can begin adding declarations.',
  SITES_MB_PERIOD_ACTION_UPDATE: 'Update mass balance period',
  SITES_MB_PERIOD_ACTION_EDIT: 'Edit period details',
  SITES_MB_PERIOD_ACTION_EDIT_SELECTED: 'Edit selected periods',
  SITES_MB_PERIOD_SCOPE: 'Terminal and site',
  SITES_MB_PERIOD_LOAD_ERROR: "Couldn't load the mass balance periods. Please try again.",
  SITES_MB_PERIOD_EDIT_TITLE: 'Edit mass balance period',
  SITES_MB_PERIOD_SAVED: 'Mass balance period saved successfully.',
  SITES_MB_PERIOD_ERROR_NO_TERMINAL: 'Select at least one terminal.',
  SITES_MB_PERIOD_ERROR_NO_PERIODS: 'Choose how many periods the year has.',
  SITES_MB_PERIOD_ERROR_COUNT: 'A year must have 4, 6 or 12 mass balance periods.',
  SITES_MB_PERIOD_ERROR_INCOMPLETE: 'Give every period a name, a start date and an end date.',
  SITES_MB_PERIOD_ERROR_TOO_SHORT: 'Every period must run for at least ${days} days.',
  SITES_MB_PERIOD_ERROR_OVERLAP:
    'Periods must run in order without overlapping — each one starts after the previous ends.',

  MATERIAL_TYPE_CONVENTIONAL: 'Conventional',
  MATERIAL_TYPE_CERTIFIED: 'Certified',

  MATERIAL_ROLE_INPUT: 'Input',
  MATERIAL_ROLE_OUTPUT: 'Output',

  STATUS_DECLARATION_SETTINGS_AVAILABLE: 'Available',
  STATUS_DECLARATION_SETTINGS_NOT_AVAILABLE: 'Not applicable',

  CERTIFICATE_TYPE_ISCC_EU: 'ISCC EU',
  CERTIFICATE_TYPE_ISCC_PLUS: 'ISCC PLUS',
  CERTIFICATE_TYPE_ISCC_CORSIA: 'ISCC CORSIA',

  STATUS_CERTIFICATION_CERTIFIED: 'Certified',
  STATUS_CERTIFICATION_NOT_CERTIFIED: 'Not certified',

  STATUS_MB_PERIOD_SCHEDULED: 'Scheduled',
  STATUS_MB_PERIOD_OPEN: 'Open',
  STATUS_MB_PERIOD_CLOSED: 'Closed',

  SITE_TYPE_TRADER: 'Trader',
  SITE_TYPE_TRADER_WITH_STORAGE: 'Trader with storage',
  SITE_TYPE_CONVERTER: 'Converter',
  SITE_TYPE_PROCESSING_UNIT: 'Processing unit',
  SITE_TYPE_WAREHOUSE: 'Warehouse',
  SITE_TYPE_POINT_OF_ORIGIN: 'Point of origin',
  SITE_TYPE_BIO_DIESEL_PLANT: 'Bio diesel plant',

  // ── Admin centre ──
  ADMIN_TITLE: 'Admin centre',
  ADMIN_TAB_ACCESS_MANAGER: 'Access manager',
  ADMIN_TAB_ACTIVITY_LOG: 'Activity log',
  ADMIN_ADD_USER: 'Add user',
  ADMIN_EDIT_USER: 'Edit user',
  ADMIN_ALL_SITES: 'All sites',
  ADMIN_SEND_REMINDER: 'Send reminder',
  ADMIN_SENDING_REMINDER: 'Sending reminder...',
  ADMIN_REVOKE: 'Revoke',
  ADMIN_REMOVE_USER_TITLE: 'Remove user: ${name}',
  ADMIN_REMOVE_USER_DESCRIPTION:
    'Are you sure you want to remove ${name}? This will revoke all access to the associated site and storage unit for this user.',
  ADMIN_REVOKE_TITLE: 'Revoke invitation: ${name}',
  ADMIN_REVOKE_DESCRIPTION:
    'Are you sure you want to revoke invitation of ${email}? This will revoke all access to the associate site and storage unit that were assigned',
  ADMIN_SEND_INVITATION: 'Send invitation',
  ADMIN_SEND_INVITATION_DESCRIPTION:
    'Are you sure you want to invite ${email} to join your organization?',
  ADMIN_SEND_AND_ADD_ANOTHER: 'Send and add another user',
  ADMIN_SITE_ACCESS_TITLE: 'Sites & Storage units access',
  ADMIN_SITES_INFO: 'The sites this user can view and work in.',
  ADMIN_STORAGE_UNITS_INFO: 'The storage units this user can view and work in.',
  ADMIN_USERS_NO_RESULTS_TITLE: 'No matching users',
  ADMIN_ACTIVITY_EMPTY_TITLE: 'No activity found',
  ADMIN_ACTIVITY_EMPTY_DESCRIPTION:
    'You will see a log of activities when members of your organization take any action on the platform',
  ADMIN_ACTIVITY_NO_RESULTS_TITLE: 'No matching activity',
  ADMIN_REMINDER_SENT: 'A reminder has been sent to the user successfully',
  ADMIN_INVITE_SENT: 'Invite sent to user to join your account',
  ADMIN_USER_UPDATED: 'User details updated successfully',
  ADMIN_USER_REMOVED: 'User removed successfully',
  ADMIN_INVITATION_REVOKED: 'Invitation revoked successfully',

  FIELD_USER_NAME: 'User name',
  FIELD_ACCESS_TYPE: 'Access type',
  FIELD_SITES_STORAGE_ACCESS: 'Sites and storage units access',
  FIELD_LAST_ACTIVE: 'Last active',
  FIELD_DATE_TIME: 'Date & Time',
  FIELD_MODULE: 'Module',
  FIELD_USER: 'User',
  FIELD_ACTIVITY: 'Activity',
  FIELD_ACTIVITY_DATE: 'Activity date',
  FIELD_USER_ROLE: 'User role',
  FIELD_SITES: 'Sites',
  FIELD_SITE_STORAGE_NAME: 'Site / storage unit name',
  FIELD_ID: 'ID',
  FORM_USER_NAME_PLACEHOLDER: 'Enter user name',
  FORM_SELECT_USER_ROLE: 'Select user role',
  FORM_SELECT_SITES: 'Select the sites',
  FORM_SELECT_STORAGE_UNITS: 'Select the storage units',
  FORM_STORAGE_UNITS_OPTIONAL: 'Storage units (Optional)',
  SECTION_USER_DETAILS: 'User details',
  FILTER_TODAY: 'Today',
  FILTER_YESTERDAY: 'Yesterday',
  FILTER_LAST_3_DAYS: 'Last 3 days',

  ROLE_SUPER_ADMIN: 'Super admin',
  ROLE_ADMIN: 'Admin',
  ROLE_SITE_MANAGER: 'Site manager',
  ROLE_MEMBER: 'Member',
  ROLE_OWNER: 'Owner',
  ROLE_AUDIT: 'Audit',
  ROLE_EXTERNAL: 'External',
  ROLE_SUPER_ADMIN_DESCRIPTION:
    'Can view, edit, and access all modules. Can add, remove or modify access for admin and members of all modules.',
  ROLE_ADMIN_DESCRIPTION:
    'Can view, edit, and access assigned modules of the multiple sites and storage units.',
  ROLE_SITE_MANAGER_DESCRIPTION:
    'Can view, edit, and access assigned modules of a single site and storage units',

  STATUS_ACCESS_ACTIVE: 'Active',
  STATUS_ACCESS_PENDING_INVITATION: 'Pending account creation',
  STATUS_ACCESS_REMOVED: 'Access removed',

  ACTIVITY_MODULE_ACCOUNT_SETUP: 'Account setup',
  ACTIVITY_MODULE_ADMIN_CENTRE: 'Admin centre',
  ACTIVITY_MODULE_INBOUNDS: 'Inbounds',
  ACTIVITY_MODULE_OUTBOUNDS: 'Outbounds',
  ACTIVITY_MODULE_NETWORK: 'Network',
  ACTIVITY_MODULE_OPERATIONS: 'Operations',
  ACTIVITY_MODULE_PRODUCTION: 'Production',
  ACTIVITY_MODULE_OTHER: 'Other',
  STATUS_CUSTOMER_SITE_CERT_VERIFIED: 'Verified',
  STATUS_CUSTOMER_SITE_CERT_REJECTED: 'Rejected',
  STATUS_CUSTOMER_SITE_CERT_NA: 'N/A',

  FIELD_CUSTOMER_NAME: 'Customer name',
  FIELD_CUSTOMER_ID: 'Customer ID',
  FIELD_PRIMARY_CONTACT_NAME: 'Primary contact name',
  FIELD_PRIMARY_CONTACT_EMAIL: 'Primary contact email ID',
  FIELD_SHIPPING_TO_SITE: 'Shipping to',
  FIELD_SHIPPING_SITE_ID: 'Shipping site ID',
  FIELD_SITE_MANAGER_EMAIL: "Site manager's email ID",
  FIELD_SITE_MANAGER_NAME: "Site manager's name",
  FIELD_ROUTE_NAME: 'Route name',
  FIELD_SENT_TO: 'Sent to',
  FIELD_TOTAL_TRANSPORTATION_EMISSIONS: 'Total transportation emissions',
  FIELD_DISTANCE_TRAIN: 'Distance (train)',
  FIELD_EMISSION_FACTOR_TRAIN: 'Emission factor (train)',
  FIELD_TOTAL_TRAIN_EMISSIONS: 'Total train emissions',
  FIELD_DISTANCE_SHIP: 'Distance (ship)',
  FIELD_EMISSION_FACTOR_SHIP: 'Emission factor (ship)',
  FIELD_TOTAL_SHIP_EMISSIONS: 'Total ship emissions',
  FIELD_DISTANCE_ROAD: 'Distance (road)',
  FIELD_EMISSION_FACTOR_ROAD: 'Emission factor (road)',
  FIELD_TOTAL_ROAD_EMISSIONS: 'Total road emissions',

  FORM_ORGANIZATION_NAME: 'Organization name',
  FORM_CHARACTER_COUNT: 'Characters: ${count}/${max}',
  FORM_PRIMARY_EMAIL_OPTIONAL: 'Primary email ID (Optional)',
  FORM_PRIMARY_EMAIL_PLACEHOLDER: 'Enter primary email ID',
  FORM_SHIPPING_TO: 'Shipping to',
  FORM_VALID_TILL_PLACEHOLDER: 'Valid to date',
  FORM_ADDRESS_LINE_1_OPTIONAL: 'Address line 1 (Optional)',
  FORM_CITY_NAME_OPTIONAL: 'City name (Optional)',
  FORM_COUNTRY_NAME_OPTIONAL: 'Country name (Optional)',
  FORM_ZIP_CODE_OPTIONAL: 'ZIP code (Optional)',
  FORM_ROUTE_NAME: 'Route name',
  FORM_ROUTE_NAME_PLACEHOLDER: 'Enter route name',
  FORM_SHIPPING_FROM: 'Shipping from',
  FORM_SEND_TO: 'Send to',
  FORM_SEND_TO_PLACEHOLDER: 'Select customer site',
  FORM_DISTANCE_BETWEEN_SITES: 'Distance between sites (km)',
  FORM_DISTANCE_BETWEEN_SITES_PLACEHOLDER: 'Enter distance',
  FORM_EMISSION_FACTOR: 'Emission factor (kgCO2 e/ton km)',
  FORM_EMISSION_FACTOR_PLACEHOLDER: 'Enter emission factor',
  FORM_TOTAL_TRANSPORTATION_EMISSIONS: 'Total transportation emissions (kgCO2 e / ton)',

  SECTION_CUSTOMER_DETAILS: 'Customer details',
  SECTION_CUSTOMER_ADDRESS_DETAILS: 'Customer address details',
  SECTION_TRANSPORTATION_DETAILS: 'Transportation details',

  VALIDATION_EMAIL_MAX_LENGTH: 'Email ID cannot have more than ${max} characters',
  VALIDATION_SITE_ID_UNIQUE:
    'Site IDs must be unique. You cannot use the same ID for multiple customer sites',
  VALIDATION_TRANSPORT_DETAIL_REQUIRED: 'Enter at least one transportation detail to continue',

  CUSTOMERS_ADD: 'Add customer',
  CUSTOMERS_EDIT_TITLE: 'Edit customer',
  CUSTOMERS_IMPORT: 'Import customers',
  CUSTOMERS_IMPORT_SITES: 'Import customer sites',
  CUSTOMERS_IMPORT_UNAVAILABLE_TITLE: 'Import not available yet',
  CUSTOMERS_IMPORT_UNAVAILABLE_DESCRIPTION:
    'Importing from a spreadsheet is coming soon. Add customers and their sites manually for now.',
  CUSTOMERS_EMPTY_TITLE: 'No customers found',
  CUSTOMERS_EMPTY_DESCRIPTION:
    'No customers have been added yet. You will need to add customers to manage outbound shipments.',
  CUSTOMERS_NO_RESULTS_TITLE: 'No matching customers',
  CUSTOMERS_LOAD_ERROR: 'Could not load this customer',
  CUSTOMERS_FORM_ID_PREFIX: 'Customer ID prefix',
  CUSTOMERS_FORM_ID_NUMBER: 'Customer ID number',
  CUSTOMERS_ACTION_ADD_SITES: 'Add customer sites',
  CUSTOMERS_ACTION_ADD_TRANSPORTATION: 'Add transportation details',
  CUSTOMERS_ADDED: 'Customer added successfully',
  CUSTOMERS_UPDATED: 'Customer updated successfully',
  CUSTOMERS_DELETED: 'Customer deleted successfully',

  CUSTOMER_DETAIL_TAB_SITES: 'Site details',
  CUSTOMER_DETAIL_TAB_TRANSPORTATION: 'Transportation details',

  CUSTOMER_SITES_ADD_TITLE: 'Add customer sites: ${customerName}',
  CUSTOMER_SITES_EDIT_TITLE: 'Edit customer sites: ${customerName}',
  CUSTOMER_SITES_FORM_ID_PREFIX: 'Shipping site ID prefix',
  CUSTOMER_SITES_FORM_ID_NUMBER: 'Shipping site ID number',
  CUSTOMER_SITES_EMPTY_TITLE: 'No sites added',
  CUSTOMER_SITES_EMPTY_DESCRIPTION:
    'No site details added. Add site details of customers to automate the details while generating declaration',
  CUSTOMER_SITES_NO_RESULTS_TITLE: 'No matching sites',
  CUSTOMER_SITES_LOAD_ERROR: 'Could not load this site',
  CUSTOMER_SITES_DELETE_TITLE: 'Delete site',
  CUSTOMER_SITES_DELETE_BODY_TITLE: 'Delete site : ${siteName}',
  CUSTOMER_SITES_DELETE_DESCRIPTION:
    "Are you sure you want to delete this site '${siteName}' from '${customerName}'?",
  CUSTOMER_SITES_ADDED: 'Site added successfully',
  CUSTOMER_SITES_UPDATED: 'Site updated successfully',
  CUSTOMER_SITES_DELETED: 'Site deleted successfully',

  CUSTOMER_TRANSPORT_EDIT_TITLE: 'Edit transportation details',
  CUSTOMER_TRANSPORT_MODE_TRAIN: 'Train',
  CUSTOMER_TRANSPORT_MODE_SHIP: 'Ship',
  CUSTOMER_TRANSPORT_MODE_ROAD: 'Road',
  CUSTOMER_TRANSPORT_EMPTY_TITLE: 'No transportation details added',
  CUSTOMER_TRANSPORT_EMPTY_DESCRIPTION:
    "Please add transportation emissions, distance, etc., to calculate the transportation emissions between your site and your customer's site.",
  CUSTOMER_TRANSPORT_DELETE_TITLE: 'Delete transportation details',
  CUSTOMER_TRANSPORT_DELETE_BODY_TITLE: 'Delete transportation details of ${routeName}',
  CUSTOMER_TRANSPORT_DELETE_DESCRIPTION:
    'Are you sure you want to delete transportation information between ${customerSiteName} and ${siteName}?',
  CUSTOMER_TRANSPORT_ADDED: 'Transportation details added successfully',
  CUSTOMER_TRANSPORT_UPDATED: 'Transportation details updated successfully',
  CUSTOMER_TRANSPORT_DELETED: 'Transportation details deleted successfully',

  // ── Assistant (product-wide chatbot) ──
  CHATBOT_OPEN: 'Ask assistant',
  CHATBOT_CLOSE: 'Close assistant',
  CHATBOT_TITLE: 'Assistant',
  CHATBOT_EMPTY:
    'Ask about your materials across contracts, shipments, orders and inventory. For example:',
  CHATBOT_PLACEHOLDER: 'Ask a question…',
  CHATBOT_SEND: 'Send',
  CHATBOT_THINKING: 'Thinking…',
  CHATBOT_ERROR: 'Something went wrong. Please try again.',
  CHATBOT_VIEW_IN_LIST: 'View in list',
  CHATBOT_SUGGESTION_CONTRACTED: 'How much soybean oil have I contracted in the last month?',
  CHATBOT_SUGGESTION_SHIPPED: 'How much have I shipped this quarter?',
  CHATBOT_SUGGESTION_IN_STOCK: 'How much rapeseed oil is in stock?',
});
